import React, { useRef, useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Anavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { complaintsconfig, Bulkuploaddata, getcomplaintsconfig, previewrdmdata, operationalvalue, createTextFileApi, shariahadminmapping, shariahmapping, updatetextfile3001, approverdmdata } from '../components/ApiProperty';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { UploadLoadingIcon, closeButtonStyle, Aprrovecolor, Rejectcolor, Listoftablesearchbox1, BackButton, RecordsPerPageSelect, SearchBox, submitButtonStyle, cancelButtonStyle, ProceedButtonStyle } from "../components/Propertyfile";
import GapsyShariahDescription from "../components/GapsyLeadershipDescription";
import { FaPlus, FaEdit, FaTrash, FaSave } from "react-icons/fa";



const GapsyLeader = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState("");
    const [tempData, setTempData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [makerRemarks, setMakerRemarks] = useState("");
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [isViewMode, setIsViewMode] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason, setRejectedReason] = useState("");
    const [showDownload, setShowDownload] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [q1, setQ1] = useState("");
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    const [reportingDate, setReportingDate] = useState("");
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");
    const [weightError, setWeightError] = useState("");
    const [gradeRows, setGradeRows] = useState([]);
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [modifiedOn, setModifiedOn] = useState("");
    const [excelRows, setExcelRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [availableReportingDates, setAvailableReportingDates] = useState([]);
    const [showChargeModal, setShowChargeModal] = useState(false);
    const [selectedReportingDate, setSelectedReportingDate] = useState([]);
    const [reportingDates1, setReportingDates1] = useState([]);
    const [capitalChargeData, setCapitalChargeData] = useState([]);
    const [excelMerges, setExcelMerges] = useState([]);
    const [editingExcelRows, setEditingExcelRows] = useState({});
    const [editingAverageRows, setEditingAverageRows] = useState({});
    const [newAverageRows, setNewAverageRows] = useState([]);
    const [complaintsConfigData, setComplaintsConfigData] = useState([]);
    const [templateVersion, setTemplateVersion] = useState(0);
    const [ratingColors, setRatingColors] = useState({});
    const excelRowsBackup = useRef(null);
    const [selectedNewSectionId, setSelectedNewSectionId] = useState(null);
    const [isNewSectionEditing, setIsNewSectionEditing] = useState(false);

    const newSectionBackup = useRef(null);

    const RATING_COLORS_BY_INDEX = [
        "#00B050", // First existing rating: Red
        "#FFC000", // Second existing rating: Yellow
        "#FF0000", // Third existing rating: Red
    ];

    const NEW_RATING_COLOR = "#A6A6A6"; // Every newly added rating
    const PARAM_COL_STYLE = {
        width: "500px",
        minWidth: "500px",
        maxWidth: "500px",
    };

    useEffect(() => { loadExcel(); }, []);

    const fmt = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            if (val > 0 && val < 1) return (val * 100).toFixed(0) + "%";
            return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
        }
        return String(val);
    };

    useEffect(() => {
        fetchPreviewData();
    }, []);

    useEffect(() => {
        operational();
    }, []);

    useEffect(() => {
        if (
            availableReportingDates?.length > 0 &&
            csrfToken &&
            department
        ) {
            fetchShariahAdminModifyData();
        }
    }, [
        availableReportingDates,
        csrfToken,
        department,
    ]);

    const parseWeight = (value) => {
        if (value === null || value === undefined || value === "") {
            return "";
        }

        if (typeof value === "string" && value.includes("%")) {
            const percentage = parseFloat(value.replace("%", "").trim());
            return isNaN(percentage) ? "" : percentage / 100;
        }

        const numericValue = Number(value);

        return isNaN(numericValue) ? "" : numericValue;
    };

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    const fetchPreviewData = async (openReportingModal = true) => {
        try {
            const [
                tempResult,
                liveResult,
                retrievedResult
            ] = await Promise.all([
                fetchTableData("Risk_leadership_thresholds_temp"),
                fetchTableData("Risk_leadership_thresholds_live"),
                fetchTableData("Risk_leadership_thresholds_retrieved")
            ]);

            const tempRows = Array.isArray(tempResult?.data)
                ? tempResult.data
                : [];

            const liveRows = Array.isArray(liveResult?.data)
                ? liveResult.data
                : [];

            const retrievedRows = Array.isArray(retrievedResult?.data)
                ? retrievedResult.data
                : [];

            console.log("Temp File:", tempResult?.fileName);
            console.log("Temp Data:", tempRows);

            console.log("Live File:", liveResult?.fileName);
            console.log("Live Data:", liveRows);

            console.log("Retrieved File:", retrievedResult?.fileName);
            console.log("Retrieved Data:", retrievedRows);

            // Update existing table states
            setTempData(tempRows);
            setLiveData(liveRows);

            // Determine the next reporting date using ALL THREE tables
            loadNextReportingDate(
                tempRows,
                liveRows,
                retrievedRows
            );

            // Merge all three tables for reporting-date history
            const allRows = [
                ...tempRows,
                ...liveRows,
                ...retrievedRows
            ];

            // Extract unique reporting dates
            const uniqueQuarters = [
                ...new Set(
                    allRows
                        .map((item) =>
                            getQuarterFromDate(item.reporting_date)
                        )
                        .filter(Boolean)
                )
            ].sort(sortQuarter);

            // Keep the latest three reporting dates
            const latestThreeReportingDates = uniqueQuarters.slice(-3);

            setReportingDates1(latestThreeReportingDates);

            if (latestThreeReportingDates.length > 0) {
                setSelectedReportingDate([]);
                setCapitalChargeData([]);
            }

        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const operational = async () => {
        try {
            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true
            };

            const apiResponse = await axios.post(operationalvalue, {}, config);

            const response = apiResponse.data;

            console.log("operationalvalue", response);

            // Use ACTUAL_VALUE if available,
            // otherwise always use PREVIOUS_VALUE
            const value =
                response.ACTUAL_VALUE !== null &&
                    response.ACTUAL_VALUE !== undefined
                    ? response.ACTUAL_VALUE
                    : response.PREVIOUS_VALUE;

            if (value !== null && value !== undefined) {
                setOperationalRiskCharge(value);
            }

        } catch (err) {
            console.error(err);
        }
    };

    const getPreviousQuarter = (quarter) => {
        if (!quarter) return "";

        const [q, yearStr] = quarter.split("-");
        let quarterNumber = Number(q.replace("Q", ""));
        let year = Number(yearStr);

        quarterNumber--;

        if (quarterNumber === 0) {
            quarterNumber = 4;
            year--;
        }

        return `Q${quarterNumber}-${year}`;
    };

    // const fetchShariahAdminModifyData = async () => {
    //     try {
    //         const currentQuarter = availableReportingDates?.[0];
    //         const reportDate = currentQuarter || "";
    //         if (!currentQuarter) {
    //             return;
    //         }

    //         // const selectedReportDate = availableReportingDates[0] || "";
    //         // const reportDate = selectedReportDate
    //         //     ? `FY ${selectedReportDate.split("-")[1]}`
    //         //     : "";

    //         const config = {
    //             headers: {
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //             params: {
    //                 userId: localStorage.getItem("userid"),
    //                 dept: department,
    //                 templateName: "COMPLAINTS"
    //             },
    //         };

    //         // --------------------------------------------------
    //         // 1. First call: current available reporting date
    //         // --------------------------------------------------
    //         let quarterToFetch = currentQuarter;
    //         // let reportDate = getReportingDate(quarterToFetch);

    //         if (!reportDate) {
    //             return;
    //         }

    //         // config.params.reportingDate = reportDate;


    //         config.params.reportingDate = reportDate;

    //         let response = await axios.post(
    //             getcomplaintsconfig,
    //             {},
    //             config
    //         );

    //         // --------------------------------------------------
    //         // 2. If current quarter has NO_DATA,
    //         //    call previous quarter
    //         // --------------------------------------------------
    //         if (response.data?.status === "NO_DATA") {

    //             const previousQuarter = getPreviousQuarter(currentQuarter);

    //             // reportDate = getReportingDate(previousQuarter);

    //             if (!reportDate) {
    //                 return;
    //             }

    //             config.params.reportingDate = reportDate;

    //             response = await axios.post(
    //                 shariahadminmapping,
    //                 {},
    //                 config
    //             );

    //             quarterToFetch = previousQuarter;
    //         }

    //         // --------------------------------------------------
    //         // 3. Process SUCCESS response
    //         // --------------------------------------------------
    //         const status = String(response.data?.status || "").toUpperCase();
    //         const dbgRows = response.data?.data ?? [];
    //         console.log("[LOG-1] API RESPONSE", {
    //             reportingDateSent: config.params.reportingDate,
    //             status,
    //             rowCount: dbgRows.length,
    //             firstRowKeys: Object.keys(dbgRows[0] ?? {}),
    //             firstRow: dbgRows[0],
    //             apiKeys: JSON.stringify([
    //                 ...new Set(
    //                     dbgRows.map(
    //                         (r) =>
    //                             `${r.CUSTOMER_TYPE ?? r.customer_type ?? "??"}|${r.SR_NO ?? r.sr_no ?? "??"}|${r.PARAMETERS ?? r.parameters ?? "??"}`
    //                     )
    //                 ),
    //             ]),
    //         });

    //         if (status === "SUCCESS" && response.data?.data?.length > 0) {

    //             //   const apiData = response.data?.data || [];

    //             setModifiedOn(response.data?.modifiedOn || "");

    //             setComplaintsConfigData(response.data.data);
    //         } else if (
    //             status === "NO_DATA" ||
    //             (status === "SUCCESS" && !response.data?.data?.length)
    //         ) {
    //             setComplaintsConfigData([]);
    //             await loadExcel();
    //         }

    //     } catch (error) {
    //         console.error(
    //             "Error fetching Shariah Admin Modify Data:",
    //             error
    //         );
    //     }
    // };


    const fetchShariahAdminModifyData = async () => {
        try {
            const currentQuarter = String(
                availableReportingDates?.[0] ?? ""
            ).trim();

            if (!currentQuarter) {
                console.warn("No reporting date available.");
                return;
            }

            const reportingDates = [
                "FY 2024",
                "FY 2025",
                "FY 2026",
                "FY 2027",
                "FY 2028",
                "FY 2029",
                "FY 2030",
            ];

            const currentIndex = reportingDates.indexOf(currentQuarter);

            if (currentIndex === -1) {
                console.error("Invalid reporting date:", currentQuarter);
                return;
            }

            const config = {
                headers: {
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    dept: department,
                    templateName: "leadership_thresholds",
                    reportingDate: currentQuarter,
                },
            };

            // Fetch configuration for a particular reporting date.
            const fetchConfiguration = async (date) => {
                console.log(
                    "Fetching complaints configuration for:",
                    date
                );

                const apiResponse = await axios.post(
                    getcomplaintsconfig,
                    {},
                    {
                        ...config,
                        params: {
                            ...config.params,
                            reportingDate: date,
                        },
                    }
                );

                const responseData = apiResponse.data || {};

                const status = String(
                    responseData.status ?? ""
                ).trim().toUpperCase();

                const message = String(
                    responseData.message ?? ""
                ).trim().toUpperCase();

                const apiData = Array.isArray(responseData.data)
                    ? responseData.data
                    : [];

                console.log("Complaints configuration response:", {
                    reportingDateSent: date,
                    status,
                    message,
                    rowCount: apiData.length,
                    firstRow: apiData[0] ?? null,
                });

                const noData =
                    ["NO_DATA", "NO-DATA", "NODATA"].includes(status) ||
                    ["NO_DATA", "NO-DATA", "NODATA"].includes(message) ||
                    (status === "SUCCESS" && apiData.length === 0);

                if (noData) {
                    return {
                        found: false,
                        data: [],
                        responseData,
                    };
                }

                if (status === "SUCCESS" && apiData.length > 0) {
                    return {
                        found: true,
                        data: apiData,
                        responseData,
                    };
                }

                throw new Error(
                    `Unexpected API response for ${date}: ${JSON.stringify(
                        responseData
                    )}`
                );
            };

            let result = {
                found: false,
                data: [],
                responseData: {},
            };

            let quarterToFetch = "";

            // Start with the selected date and keep moving backwards.
            for (let i = currentIndex; i >= 0; i--) {
                const dateToFetch = reportingDates[i];

                console.log(
                    `Checking reporting date: ${dateToFetch}`
                );

                result = await fetchConfiguration(dateToFetch);

                if (result.found) {
                    quarterToFetch = dateToFetch;

                    console.log(
                        `Data found for ${quarterToFetch}. Stopping retries.`
                    );

                    break;
                }

                console.log(
                    `NO_DATA for ${dateToFetch}. ` +
                    "Checking the previous reporting date."
                );
            }

            // Process the first successful response.
            if (result.found) {
                setModifiedOn(result.responseData?.modifiedOn || "");
                setComplaintsConfigData(result.data);

                console.log(
                    `Complaints configuration loaded successfully for ${quarterToFetch}.`
                );

                return;
            }

            // No data was found for any reporting date.
            setComplaintsConfigData([]);

            console.log(
                `No complaints configuration found from ${currentQuarter} ` +
                "back to FY 2024."
            );

            await loadExcel();

        } catch (error) {
            console.error(
                "Error fetching Shariah Admin Modify Data:",
                error
            );

            setComplaintsConfigData([]);
        }
    };


    const headerRowIndex = excelRows.findIndex((row) =>
        row.some((cell) =>
            String(cell).trim().toLowerCase() === "parameters"
        )
    );


    const averageRowIndex = excelRows.findIndex((row) =>
        row.some((cell) =>
            String(cell).trim().toLowerCase() === "rating"
        )
    );

    useEffect(() => {
        if (!complaintsConfigData.length || !excelRows.length) return;

        const norm = (v) =>
            String(v ?? "")
                .replace(/[\r\n]+/g, " ")
                .replace(/\s*-\s*/g, "-")
                .replace(/\s+/g, " ")
                .trim()
                .toLowerCase();

        // API may return upper- or lower-case keys
        const get = (item, key) => item[key] ?? item[key.toLowerCase()] ?? "";

        const canonType = (v) => {
            const n = norm(v);
            if (n === "retail customers") return "Retail Customers";
            if (n === "non-retail customers") return "Non-Retail Customers";
            return String(v ?? "").trim();
        };

        const typeOrder = { "retail customers": 0, "non-retail customers": 1 };

        // Keep only the static top of the Excel (title + header row)
        const hdrIdx = excelRows.findIndex((row) =>
            row.some((c) => norm(c) === "parameters")
        );
        const ratingIdx = excelRows.findIndex(
            (row, i) => i > hdrIdx && row.some((c) => norm(c) === "rating")
        );

        const rows = excelRows.slice(0, hdrIdx + 1).map((r) => [...r]);
        const merges = excelMerges
            .filter((m) => m.e.r <= hdrIdx)
            .map((m) => ({ s: { ...m.s }, e: { ...m.e } }));

        // Group saved rows: customer type + Sr. No (used only for grouping)
        const groups = new Map();
        complaintsConfigData.forEach((item) => {
            const type = canonType(get(item, "CUSTOMER_TYPE"));
            const sr = String(get(item, "SR_NO")).trim();
            const key = `${norm(type)}|${sr}`;
            if (!groups.has(key)) {
                groups.set(key, {
                    type,
                    sr,
                    parameter: String(get(item, "PARAMETERS")).trim(),
                    items: [],
                });
            }
            groups.get(key).items.push(item);
        });

        const ordered = [...groups.values()].sort(
            (a, b) =>
                (typeOrder[norm(a.type)] ?? 9) - (typeOrder[norm(b.type)] ?? 9) ||
                Number(a.sr) - Number(b.sr)
        );

        // Build the main table from the saved data
        let lastType = "";
        let typeMerge = null;

        ordered.forEach((g) => {
            const start = rows.length;
            const isNewType = norm(g.type) !== lastType;

            if (isNewType) {
                lastType = norm(g.type);
                typeMerge = { s: { r: start, c: 0 }, e: { r: start, c: 0 } };
                merges.push(typeMerge);
            }

            // heading row + threshold rows
            // heading row carries Sr. No + Parameter (top-left of the merged cells)
            rows.push([isNewType ? g.type : "", g.sr, g.parameter, "From", "To", "Score"]);
            g.items.forEach((item) => {
                rows.push([
                    "",
                    "",   // Sr. No only on the first row of the block
                    "",   // Parameter only on the first row of the block
                    get(item, "FROM_THRESHOLD"),
                    get(item, "TO_THRESHOLD"),
                    get(item, "SCORE_THRESHOLD"),
                ]);
            });

            const end = rows.length - 1;
            typeMerge.e.r = end;
            merges.push({ s: { r: start, c: 1 }, e: { r: end, c: 1 } });
            merges.push({ s: { r: start, c: 2 }, e: { r: end, c: 2 } });
        });

        // Rating / Average Score table
        if (ratingIdx !== -1) {
            const newRatingIdx = rows.length;
            rows.push([...excelRows[ratingIdx]]);

            // keep any merges that belong to the rating header row
            excelMerges
                .filter((m) => m.s.r >= ratingIdx)
                .forEach((m) =>
                    merges.push({
                        s: { r: m.s.r - ratingIdx + newRatingIdx, c: m.s.c },
                        e: { r: m.e.r - ratingIdx + newRatingIdx, c: m.e.c },
                    })
                );

            const seen = new Set();
            complaintsConfigData.forEach((item) => {
                const section = String(get(item, "SCORE") || get(item, "SECTION") || "").trim();
                const rating = String(get(item, "RATING") || "").trim();
                const avg = String(get(item, "AVERAGE_SCORE") || "").trim();
                if (!section && !rating && !avg) return;

                const key = `${section}|${rating}|${avg}`;
                if (seen.has(key)) return;
                seen.add(key);

                const r = Array(6).fill("");
                r[3] = section;
                r[4] = rating;
                r[5] = avg;
                rows.push(r);
            });
        }

        console.log("[REBUILD FROM JSON]", {
            templateVersion,
            savedRows: complaintsConfigData.length,
            groups: ordered.map((g) => `${g.type}|${g.sr}|${g.parameter}`),
            totalRows: rows.length,
        });

        setExcelRows(rows);
        setExcelMerges(merges);

        // Drop any unsaved in-memory additions; saved data is now the source
        setNewComplaintSections([]);
        setNewAverageRows([]);
        setEditingExcelRows({});
        setEditingAverageRows({});
    }, [complaintsConfigData, templateVersion]);


    const str = (c) => (c == null ? "" : String(c).trim());

    const c1 = (row) => {
        if (!row || !Array.isArray(row)) return "";
        return str(row[1]);
    };

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };

    const validateReportingDate = (quarter) => {

        if (!quarter) return;

        const reportDate = getReportingDate(quarter);

        // ================= LIVE TABLE =================

        const liveRecord = liveData.find(
            row => row.reporting_date === reportDate
        );

        if (liveRecord) {

            setReportingMessage(
                `Reporting Date ${quarter} data is already stored in Permanent Area. Please select another Reporting Date.`
            );

            setAllowSubmit(false);
            setShowReportingModal(true);
            return;
        }

        // ================= TEMP TABLE =================

        const tempRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        if (tempRecords.length === 0) {

            // No records -> Fresh reporting date
            setAllowSubmit(true);
            setShowReportingModal(false);
            return;
        }

        // Normalize rejected reason
        const normalize = (value) =>
            (value || "")
                .toString()
                .trim()
                .toLowerCase();

        // Check whether ALL records are rejected
        const allRejected = tempRecords.every(
            row => normalize(row.Rejected_Reason) === "rejected"
        );

        // Check whether ALL records are blank/\N/NULL
        const allPending = tempRecords.every(row => {
            const reason = normalize(row.Rejected_Reason);

            return (
                reason === "" ||
                reason === "\\n" ||
                reason === "\n" ||
                reason === "null"
            );
        });

        if (allRejected) {

            setReportingMessage(
                `Reporting Date ${quarter} record got rejected. Please go to the Modify Screen, update the record and submit it again.`
            );

            setAllowSubmit(false);
        }
        else if (allPending) {

            setReportingMessage(
                `Reporting Date ${quarter} data is already submitted and pending for Checker Review.`
            );

            setAllowSubmit(false);
        }
        else {

            // Mixed status (optional fallback)
            setReportingMessage(
                `Reporting Date ${quarter} record got rejected. Please go to the Modify Screen, update the record and submit it again.`
            );

            setAllowSubmit(false);
        }

        setShowReportingModal(true);
    };


    // const loadNextReportingDate = (temp, live) => {
    //     const usedDates = new Set(
    //         [...temp, ...live]
    //             .map((row) => String(row.reporting_date ?? "").trim())
    //             .filter(Boolean)
    //     );

    //     const nextQuarter = reportingDates.find(
    //         (item) => !usedDates.has(item)
    //     );

    //     if (nextQuarter) {
    //         setAvailableReportingDates([nextQuarter]);
    //         setReportingDate(nextQuarter);
    //     } else {
    //         setAvailableReportingDates([]);
    //         setReportingDate("");
    //     }

    //     console.log("Used reporting dates:", [...usedDates]);
    //     console.log("Next reporting date:", nextQuarter || "None");
    // };

    const loadNextReportingDate = (temp = [], live = [], retrieved = []) => {
        // Combine all three table responses
        const allRows = [
            ...(Array.isArray(temp) ? temp : []),
            ...(Array.isArray(live) ? live : []),
            ...(Array.isArray(retrieved) ? retrieved : [])
        ];

        // Collect reporting dates from all tables
        const usedDates = new Set(
            allRows
                .map((row) => String(row.reporting_date ?? "").trim())
                .filter(Boolean)
        );

        let nextReportingDate = reportingDates[0];

        if (usedDates.size > 0) {
            // Find the latest reporting date present in any table
            const usedIndexes = [...usedDates]
                .map((date) => reportingDates.indexOf(date))
                .filter((index) => index !== -1);

            if (usedIndexes.length > 0) {
                const latestIndex = Math.max(...usedIndexes);

                // Select the next financial year
                nextReportingDate = reportingDates[latestIndex + 1] || "";
            }
        }

        // Update the reporting date input
        if (nextReportingDate) {
            setAvailableReportingDates([nextReportingDate]);
            setReportingDate(nextReportingDate);
        } else {
            setAvailableReportingDates([]);
            setReportingDate("");
        }

        console.log("Used reporting dates:", [...usedDates]);
        console.log("Next reporting date:", nextReportingDate || "None");
    };

    const reportingDates = [
        "FY 2024",
        "FY 2025",
        "FY 2026",
        "FY 2027",
        "FY 2028",
        "FY 2029",
        "FY 2030"
    ];


    const getFinancialYear = (quarter) => {
        if (!quarter) return "";

        if (/^FY\s+\d{4}$/.test(quarter)) {
            return quarter;
        }

        const parts = quarter.split("-");

        if (parts.length >= 2 && parts[1]) {
            return `FY ${parts[1].trim()}`;
        }

        return quarter;
    };


    const financialYears = [
        ...new Set(reportingDates.map(getFinancialYear))
    ];



    const handleCancel = async () => {
        restoreExcelValues();

        setShowModal(false);
        await fetchShariahAdminModifyData();

        setModalMessage('');

    };

    const normalize = (value) =>
        String(value ?? "")
            .replace(/[\r\n]+/g, " ")
            .replace(/\s*-\s*/g, "-")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();


    const loadExcel = async () => {
        try {
            const response = await fetch(
                "/templates/Leadership.xlsx"
            );

            if (!response.ok) {
                throw new Error("Unable to load Excel file.");
            }

            const data = await response.arrayBuffer();

            const workbook = XLSX.read(data, {
                type: "array",
                cellStyles: true
            });

            const sheetName = "Complaints Thresholds";
            const worksheet = workbook.Sheets[sheetName];

            if (!worksheet) {
                throw new Error(`${sheetName} sheet not found.`);
            }


            // const rows = XLSX.utils.sheet_to_json(worksheet, {
            //     header: 1,
            //     defval: "",
            //     raw: false,
            // });


            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: "",
                raw: false,
            });

            // Remove completely empty rows from the first table data.
            const isEmptyRow = (row) =>
                row.every((cell) => String(cell ?? "").trim() === "");

            const averageRowIndex = rows.findIndex((row) =>
                row.some(
                    (cell) =>
                        String(cell ?? "").trim().toLowerCase() === "rating"
                )
            );


            if (averageRowIndex !== -1) {
                // Remove completely empty rows before the Rating section.
                for (let i = averageRowIndex - 1; i > headerRowIndex; i--) {
                    if (isEmptyRow(rows[i])) {
                        rows.splice(i, 1);
                    }
                }
            }



            // Renumber the original serial numbers sequentially.
            let nextSNo = 0;

            const normalize = (value) =>
                String(value ?? "")
                    .replace(/[\r\n]+/g, " ")
                    .replace(/\s*-\s*/g, "-")
                    .replace(/\s+/g, " ")
                    .trim()
                    .toLowerCase();

            let currentCustomerType = "";

            rows.forEach((row) => {
                const customerLabel = row
                    .map(normalize)
                    .find(
                        (value) =>
                            value === "retail customers" ||
                            value === "non-retail customers"
                    );

                if (customerLabel) {
                    currentCustomerType = customerLabel;
                }

                // Column 1 is the Sr. No column.
                if (
                    currentCustomerType &&
                    /^\d+$/.test(String(row[1] ?? "").trim())
                ) {
                    nextSNo++;
                    row[1] = nextSNo;
                }
            })

            const getCellBackgroundColor = (cell) => {
                const color = cell?.s?.fill?.fgColor;

                if (color?.rgb) {
                    const rgb = String(color.rgb).replace(/^FF/i, "");
                    return `#${rgb}`;
                }

                if (color?.argb) {
                    const argb = String(color.argb);
                    return `#${argb.length === 8 ? argb.slice(2) : argb}`;
                }

                return "";
            };

            // Extract existing colors from the Rating column (Excel column E).
            const extractedRatingColors = {};

            rows.forEach((row, rowIndex) => {
                const rating = String(row[4] ?? "").trim();

                if (!rating || normalize(rating) === "rating") {
                    return;
                }

                const cellAddress = XLSX.utils.encode_cell({
                    r: rowIndex,
                    c: 4,
                });

                const backgroundColor = getCellBackgroundColor(
                    worksheet[cellAddress]
                );

                if (backgroundColor) {
                    extractedRatingColors[normalize(rating)] = backgroundColor;
                }
            });

            setRatingColors(extractedRatingColors);

            setExcelRows(rows);
            setExcelMerges(worksheet["!merges"] || []);
            setTemplateVersion((v) => v + 1);

            console.log("Excel Rows:", rows);

        } catch (err) {
            console.error("Error loading Excel:", err);
        } finally {
            setLoading(false);
        }
    };


    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const renderKeyAreaText = (text) => {
        if (!text) return null;
        return String(text).split("\n").map((line, i) => {
            if (!line.trim()) return null;
            if (line.startsWith("-")) {
                return <li key={i} className="mb-1">{line.replace(/^-\s*/, "")}</li>;
            }
            return <p key={i} className="mb-1 fw-semibold">{line}</p>;
        });
    };

    const handleEditExcelRow = (rowIndex) => {
        const parameterMerge = excelMerges.find(
            (m) =>
                m.s.c === 2 &&
                m.e.c === 2 &&
                rowIndex >= m.s.r &&
                rowIndex <= m.e.r
        );

        setEditingExcelRows((prev) => ({
            ...prev,
            [rowIndex]: true,
            ...(parameterMerge
                ? { [parameterMerge.s.r]: true }
                : {}),
        }));
    };

    const handleSaveExcelRow = (rowIndex) => {
        const parameterMerge = excelMerges.find(
            (m) =>
                m.s.c === 2 &&
                m.e.c === 2 &&
                rowIndex >= m.s.r &&
                rowIndex <= m.e.r
        );

        setEditingExcelRows((prev) => {
            const updated = { ...prev };

            // Stop editing the selected row.
            updated[rowIndex] = false;

            // Stop editing the merged Parameter cell.
            if (parameterMerge) {
                updated[parameterMerge.s.r] = false;
            }

            return updated;
        });
    };

    const handleAddAverageRow = () => {
        setNewAverageRows((prev) => [
            ...prev,
            {
                id: Date.now(),
                section: "",
                rating: "",
                averageScore: "",
                color: NEW_RATING_COLOR,
            },
        ]);
    };

    const handleAverageRowChange = (id, field, value) => {
        setNewAverageRows((prev) =>
            prev.map((row) =>
                row.id === id
                    ? { ...row, [field]: value }
                    : row
            )
        );
    };

    const handleEditAverageRow = (rowIndex) => {
        setEditingAverageRows((prev) => ({
            ...prev,
            [rowIndex]: true,
        }));
    };

    const handleSaveAverageRow = (rowIndex) => {
        setEditingAverageRows((prev) => ({
            ...prev,
            [rowIndex]: false,
        }));
    };

    const handleDeleteNewAverageRow = (id) => {
        setNewAverageRows((prev) =>
            prev.filter((row) => row.id !== id)
        );
    };

    const handleSaveNewAverageRow = (id) => {
        const rowToSave = newAverageRows.find((row) => row.id === id);

        if (!rowToSave) return;

        if (
            !rowToSave.section.trim() ||
            !rowToSave.rating.trim() ||
            !rowToSave.averageScore.trim()
        ) {
            alert("Please fill Section, Rating, and Average Score.");
            return;
        }

        // Add the row to excelRows using the existing column positions.
        setExcelRows((prev) => {
            const updatedRows = prev.map((row) => [...row]);

            const newRow = Array(
                Math.max(6, ...updatedRows.map((row) => row.length))
            ).fill("");

            newRow[3] = rowToSave.section;
            newRow[4] = rowToSave.rating;
            newRow[5] = rowToSave.averageScore;

            updatedRows.push(newRow);

            return updatedRows;
        });

        setNewAverageRows((prev) =>
            prev.filter((row) => row.id !== id)
        );
    };


    const handleDeleteExcelRow = (rowIndex) => {
        // console.log({ rowIndex, type: typeof rowIndex, len: excelRows.length, row: excelRows[rowIndex] });
        const normalize = (value) =>
            String(value ?? "").trim().toLowerCase();

        const isHeaderRow = (row) =>
            normalize(row?.[3]) === "from" &&
            normalize(row?.[4]) === "to" &&
            normalize(row?.[5]) === "score";

        const hasThresholdData = (row) =>
            [3, 4, 5].some(
                (colIndex) =>
                    String(row?.[colIndex] ?? "").trim() !== ""
            );

        // Validate the selected row before deleting anything.
        if (
            rowIndex < 0 ||
            rowIndex >= excelRows.length ||
            !excelRows[rowIndex]
        ) {
            return;
        }

        // Find the Sr No merged block containing the selected row.
        const serialMerge = excelMerges.find(
            (merge) =>
                merge.s.c === 1 &&
                merge.e.c === 1 &&
                rowIndex >= merge.s.r &&
                rowIndex <= merge.e.r
        );

        let deleteStart = rowIndex;
        let deleteCount = 1;

        if (serialMerge) {
            const blockStart = serialMerge.s.r;
            const blockEnd = serialMerge.e.r;

            // Find the threshold header inside this Sr No block.
            let headerIndex = -1;

            for (let i = blockStart; i <= blockEnd; i++) {
                if (isHeaderRow(excelRows[i])) {
                    headerIndex = i;
                    break;
                }
            }

            // Count only actual threshold data rows.
            // Blank rows and From/To/Score headings are excluded.
            const thresholdRows = [];

            if (headerIndex !== -1) {
                for (let i = headerIndex + 1; i <= blockEnd; i++) {
                    if (
                        excelRows[i] &&
                        !isHeaderRow(excelRows[i]) &&
                        hasThresholdData(excelRows[i])
                    ) {
                        thresholdRows.push(i);
                    }
                }
            }

            // Delete the complete complaint block only when the
            // selected row is its last remaining threshold data row.
            if (
                thresholdRows.includes(rowIndex) &&
                thresholdRows.length === 1
            ) {
                deleteStart = blockStart;
                deleteCount = blockEnd - blockStart + 1;
            }
        }

        const deleteEnd = deleteStart + deleteCount - 1;

        // Preserve the customer-type label if its first row is deleted.
        const customerMerge = excelMerges.find(
            (merge) =>
                merge.s.c === 0 &&
                merge.e.c === 0 &&
                merge.s.r <= deleteStart &&
                merge.e.r >= deleteStart
        );

        const customerLabel =
            customerMerge && customerMerge.s.r >= deleteStart &&
                customerMerge.s.r <= deleteEnd
                ? excelRows[customerMerge.s.r]?.[0]
                : null;

        // Remove the selected row or complete final complaint block.
        setExcelRows((prev) => {
            const rows = prev.map((row) => [...row]);

            rows.splice(deleteStart, deleteCount);

            // Preserve the customer label in the surviving merged block.
            if (
                customerLabel &&
                customerMerge &&
                rows[deleteStart] &&
                customerMerge.e.r > deleteEnd
            ) {
                rows[deleteStart][0] = customerLabel;
            }

            return renumberSerialNumbers(rows);
        });

        // Recalculate merge coordinates after the deletion.
        setExcelMerges((prev) =>
            prev.flatMap((merge) => {
                const updated = {
                    s: { ...merge.s },
                    e: { ...merge.e },
                };

                // Merge lies entirely before the deleted rows.
                if (updated.e.r < deleteStart) {
                    return [updated];
                }

                // Merge lies entirely after the deleted rows.
                if (updated.s.r > deleteEnd) {
                    updated.s.r -= deleteCount;
                    updated.e.r -= deleteCount;
                    return [updated];
                }

                // Calculate the surviving portion of an overlapping merge.
                const newStart =
                    updated.s.r < deleteStart
                        ? updated.s.r
                        : deleteStart;

                const newEnd =
                    updated.e.r > deleteEnd
                        ? updated.e.r - deleteCount
                        : deleteStart - 1;

                // The entire merge was deleted.
                if (newEnd < newStart) {
                    return [];
                }

                updated.s.r = newStart;
                updated.e.r = newEnd;

                return [updated];
            })


        );


        setNewComplaintSections((prev) =>
            prev.map((section) => {
                const insertAt = section.insertBeforeRow;

                let updatedInsertAt = insertAt;

                // The section's insertion point was below the deleted rows.
                if (insertAt > deleteEnd) {
                    updatedInsertAt = insertAt - deleteCount;
                }
                // The insertion point was inside the deleted range.
                else if (insertAt >= deleteStart) {
                    updatedInsertAt = deleteStart;
                }

                return {
                    ...section,
                    insertBeforeRow: updatedInsertAt,
                };
            })
        );

        setEditingExcelRows({});


        setEditingExcelRows({});
    };


    const renumberSerialNumbers = (rows) => {
        const updatedRows = rows.map((row) => [...row]);
        let serialNo = 0;

        updatedRows.forEach((row) => {
            const value = String(row[1] ?? "").trim();

            // A numeric value in column 1 marks a new Sr No group.
            if (/^\d+$/.test(value)) {
                serialNo++;

                // Assign the next sequential number.
                row[1] = String(serialNo);
            }
        });

        return updatedRows;
    };



    const handleAddExcelRow = (rowIndex) => {
        const insertAt = rowIndex + 1;

        setExcelRows((prev) => {
            const sourceRow = prev[rowIndex];
            if (!sourceRow) return prev;

            const newRow = sourceRow.map(() => "");

            // Preserve Parameter as display-only; do not edit it.
            newRow[2] = sourceRow[2] ?? "";

            // Only From, To, and Score are editable.
            newRow[3] = "";
            newRow[4] = "";
            newRow[5] = "";

            return [
                ...prev.slice(0, insertAt),
                newRow,
                ...prev.slice(insertAt),
            ];
        });

        setExcelMerges((prev) =>
            prev.map((merge) => {
                const updated = {
                    s: { ...merge.s },
                    e: { ...merge.e },
                };

                // Extend a merge when inserting within or at its last row.
                if (
                    updated.s.r <= rowIndex &&
                    updated.e.r >= rowIndex
                ) {
                    updated.e.r++;
                } else if (updated.s.r >= insertAt) {
                    updated.s.r++;
                    updated.e.r++;
                }

                return updated;
            })
        );

        setEditingExcelRows((prev) => {
            const updated = {};

            Object.entries(prev).forEach(([index, isEditing]) => {
                const oldIndex = Number(index);
                updated[oldIndex >= insertAt ? oldIndex + 1 : oldIndex] =
                    isEditing;
            });

            // Enable editing only for the inserted row.
            updated[insertAt] = true;

            return updated;
        });
    };


    const handleExcelCellChange = (rowIndex, colIndex, value) => {
        setExcelRows((prev) => {
            const rows = prev.map((row) => [...row]);

            if (!rows[rowIndex]) {
                return prev;
            }

            // Update only the cell being edited.
            // Do not modify the next row's From value.
            rows[rowIndex][colIndex] = value;

            return rows;
        });
    };

    //  const handleExcelCellChange = (rowIndex, colIndex, value) => {
    //     const normalize = (v) =>
    //         String(v ?? "").trim().replace(/\s/g, "").toUpperCase();

    //     const getNumber = (v) => {
    //         const normalized = normalize(v);
    //         if (!/^\d+(?:\.\d*)?%?$/.test(normalized)) return null;

    //         const number = Number(normalized.replace("%", ""));
    //         return Number.isFinite(number) ? number : null;
    //     };

    //     // Validate threshold inputs. Maximum allowed is 100%.
    //     if (colIndex === 3 || colIndex === 4) {
    //         if (value.trim() !== "" && !/^\d*\.?\d*%?$/.test(value.trim())) {
    //             return;
    //         }

    //         const number = getNumber(value);

    //         if (number !== null && (number < 0 || number > 100)) {
    //             return;
    //         }
    //     }

    //     setExcelRows((prev) => {
    //         const rows = prev.map((row) => [...row]);
    //         rows[rowIndex][colIndex] = value;

    //         // Only recalculate ranges when From or To changes.
    //         if (colIndex !== 3 && colIndex !== 4) return rows;

    //         const isHeaderRow = (row) =>
    //             normalize(row[3]) === "FROM" &&
    //             normalize(row[4]) === "TO" &&
    //             normalize(row[5]) === "SCORE";

    //         const isThresholdRow = (row) =>
    //             !isHeaderRow(row) &&
    //             (
    //                 normalize(row[3]) !== "" ||
    //                 normalize(row[4]) !== "" ||
    //                 normalize(row[5]) !== ""
    //             );

    //         const dataRows = rows
    //             .map((row, index) => ({ row, index }))
    //             .filter(({ row, index }) =>
    //                 index > rowIndex && isThresholdRow(row)
    //             );

    //         let previousTo = getNumber(rows[rowIndex][4]);
    //         let specialTo = normalize(rows[rowIndex][4]);

    //         for (const { row, index } of dataRows) {
    //             if (previousTo !== null) {
    //                 rows[index][3] = `${previousTo}%`;
    //             } else if (specialTo === "100%+") {
    //                 rows[index][3] = "100%";
    //             } else {
    //                 break;
    //             }

    //             const fromNumber = getNumber(rows[index][3]);
    //             let toNumber = getNumber(rows[index][4]);

    //             // A To value cannot be less than its From value.
    //             if (
    //                 fromNumber !== null &&
    //                 toNumber !== null &&
    //                 toNumber < fromNumber
    //             ) {
    //                 toNumber = fromNumber;
    //                 rows[index][4] = `${toNumber}%`;
    //             }

    //             // Carry forward this row's To, not its From.
    //             previousTo = getNumber(rows[index][4]);
    //             specialTo = normalize(rows[index][4]);

    //             // Stop once the maximum is reached.
    //             if (previousTo === 100) {
    //                 break;
    //             }
    //         }

    //         return rows;
    //     });
    // };

    const [newComplaintSections, setNewComplaintSections] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");

    const handleDeleteNewSection = (sectionId) => {
        setNewComplaintSections((prev) =>
            prev.filter((section) => section.id !== sectionId)
        );
    };

    const handleAddNewRow = (customerType) => {
        if (!customerType || !excelRows.length) return;

        const normalize = (value) =>
            String(value ?? "")
                .replace(/[\r\n]+/g, " ")
                .replace(/\s*-\s*/g, "-")
                .replace(/\s+/g, " ")
                .trim()
                .toLowerCase();

        const selectedType = normalize(customerType);
        const isRetail = selectedType === "retail customers";
        const isNonRetail = selectedType === "non-retail customers";

        if (!isRetail && !isNonRetail) return;

        const isCustomerType = (value) => {
            const valueNormalized = normalize(value);
            return (
                valueNormalized === "retail customers" ||
                valueNormalized === "non-retail customers"
            );
        };

        const tableEnd =
            averageRowIndex !== -1
                ? averageRowIndex
                : excelRows.length;

        const customerStart = excelRows.findIndex((row) =>
            row.some((cell) => normalize(cell) === selectedType)
        );

        if (customerStart === -1) {
            console.error("Customer type not found:", customerType);
            return;
        }

        let customerEnd = tableEnd;

        for (let i = customerStart + 1; i < tableEnd; i++) {
            if (excelRows[i].some(isCustomerType)) {
                customerEnd = i;
                break;
            }
        }

        const serialCol = 1;
        const serialRows = [];

        for (let i = customerStart; i < customerEnd; i++) {
            const serial = normalize(excelRows[i][serialCol]);

            if (/^\d+$/.test(serial)) {
                serialRows.push({
                    rowIndex: i,
                    serial: Number(serial),
                });
            }
        }

        if (!serialRows.length) {
            console.error("No serial-number block found:", customerType);
            return;
        }

        // Clone the last complete block for the selected customer type.
        const blockStart = serialRows[serialRows.length - 1].rowIndex;
        const blockEnd = customerEnd;

        const sourceRows = excelRows
            .slice(blockStart, blockEnd)
            .map((row) => [...row]);

        // Remove trailing blank rows.
        while (
            sourceRows.length &&
            sourceRows[sourceRows.length - 1].every(
                (cell) => normalize(cell) === ""
            )
        ) {
            sourceRows.pop();
        }

        if (!sourceRows.length) return;

        // Restore the merged customer-type label.
        sourceRows[0][0] = customerType;

        // Preserve the headings, but clear existing threshold values.
        sourceRows.forEach((row, rowIndex) => {
            if (rowIndex > 0) {
                [3, 4, 5].forEach((colIndex) => {
                    if (colIndex < row.length) {
                        row[colIndex] = "";
                    }
                });
            }
        });

        const existingRetailSections = newComplaintSections.filter(
            (section) => normalize(section.customerType) === "retail customers"
        );

        const existingNonRetailSections = newComplaintSections.filter(
            (section) => normalize(section.customerType) === "non-retail customers"
        );

        const originalMax = Math.max(
            ...serialRows.map((item) => item.serial)
        );

        // Keep numbering continuous across both customer types.
        const nextSNo = isRetail
            ? originalMax + existingRetailSections.length + 1
            : originalMax +
            existingNonRetailSections.length +
            existingRetailSections.length +
            1;

        sourceRows[0][serialCol] = String(nextSNo);

        // Copy merges belonging to the cloned block.
        const merges = excelMerges
            .filter(
                (merge) =>
                    merge.s.r >= blockStart &&
                    merge.e.r < blockEnd
            )
            .map((merge) => ({
                s: {
                    r: merge.s.r - blockStart,
                    c: merge.s.c,
                },
                e: {
                    r: merge.e.r - blockStart,
                    c: merge.e.c,
                },
            }));

        // Merge the customer type and serial number across the new block.
        [0, serialCol].forEach((colIndex) => {
            const alreadyMerged = merges.some(
                (merge) =>
                    merge.s.r === 0 &&
                    merge.s.c === colIndex &&
                    merge.e.r === sourceRows.length - 1 &&
                    merge.e.c === colIndex
            );

            if (!alreadyMerged) {
                merges.push({
                    s: { r: 0, c: colIndex },
                    e: { r: sourceRows.length - 1, c: colIndex },
                });
            }
        });

        const newSection = {
            id: `${Date.now()}-${newComplaintSections.length}`,
            customerType,
            sNo: nextSNo,
            rows: sourceRows,
            merges,
            insertBeforeRow: customerEnd,
        };

        setNewComplaintSections((prev) => {
            // Adding a Retail block shifts every existing Non-Retail block by one.
            const adjustedSections = isRetail
                ? prev.map((section) => {
                    if (normalize(section.customerType) !== "non-retail customers") {
                        return section;
                    }

                    const updatedRows = section.rows.map((row) => [...row]);
                    updatedRows[0][serialCol] = String(section.sNo + 1);

                    return {
                        ...section,
                        sNo: section.sNo + 1,
                        rows: updatedRows,
                    };
                })
                : prev;

            return [...adjustedSections, newSection];
        });

        // Automatically select the newly created parameter
        // and enable edit mode immediately
        newSectionBackup.current = structuredClone(newComplaintSections);

        setSelectedGroup(null);
        setSelectedNewSectionId(newSection.id);
        setIsNewSectionEditing(true);

        setSelectedCustomerType("");
    };

    const totalWeight = indexRows.reduce(
        (sum, row) => sum + (Number(row.weight) || 0),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows = gradeRows.map((row) => {
        const index = Number(totalIndex);

        let applicable = false;

        if (row.scoreGrade?.startsWith(">")) {
            const nums =
                row.scoreGrade
                    .match(/\d+(?:\.\d+)?/g)
                    ?.map(Number) || [];

            if (nums.length === 1) {
                // >12
                applicable = index > nums[0];
            } else if (nums.length >= 2) {
                // >3-5
                applicable =
                    index > nums[0] &&
                    index <= nums[1];
            }
        } else {
            // 0-3
            const nums =
                row.scoreGrade
                    ?.match(/\d+(?:\.\d+)?/g)
                    ?.map(Number) || [];

            if (nums.length >= 2) {
                applicable =
                    index >= nums[0] &&
                    index <= nums[1];
            }
        }

        return {
            ...row,
            applicablePercentage: applicable
                ? Number(row.percentage) || 0
                : 0
        };
    });

    const [selectedGroup, setSelectedGroup] = useState(null); // groupStart row index

    useEffect(() => {
        if (selectedGroup === null) return;

        const stillExists = excelMerges.some(
            (m) => m.s.c === 2 && m.e.c === 2 && m.s.r === selectedGroup
        );

        if (!stillExists || !excelRows[selectedGroup]) {
            setSelectedGroup(null);
        }
    }, [excelRows, excelMerges, selectedGroup]);

    const isThresholdHeaderRow = (row) =>
        row.some((cell) =>
            ["from", "to", "score"].includes(String(cell ?? "").trim().toLowerCase())
        );

    const isEmptyThresholdRow = (row, rowIndex) => {
        const parameterMerge = excelMerges.find(
            (m) => m.s.c === 2 && m.e.c === 2 && rowIndex >= m.s.r && rowIndex <= m.e.r
        );
        const hasThresholdData = [3, 4, 5].some(
            (c) => String(row[c] ?? "").trim() !== ""
        );
        return (
            !!parameterMerge &&
            !isThresholdHeaderRow(row) &&
            !hasThresholdData &&
            !editingExcelRows[rowIndex]
        );
    };

    const getGroupRows = (rowIndex) => {
        const merge = excelMerges.find(
            (m) => m.s.c === 2 && m.e.c === 2 && rowIndex >= m.s.r && rowIndex <= m.e.r
        );
        const groupStart = merge ? merge.s.r : rowIndex;
        const groupEnd = merge ? merge.e.r : rowIndex;
        const visibleRows = [];
        for (let i = groupStart; i <= groupEnd; i++) {
            if (!isEmptyThresholdRow(excelRows[i], i)) visibleRows.push(i);
        }
        return { groupStart, groupEnd, visibleRows };
    };

    const toggleGroup = (groupStart) =>
        setSelectedGroup((prev) => (prev === groupStart ? null : groupStart));

    // used by the toolbar
    const selectedRows =
        selectedGroup !== null ? getGroupRows(selectedGroup).visibleRows : [];
    const isSelectedEditing = selectedRows.some((i) => editingExcelRows[i]);

    const handleGradeChange = (rowIndex, field, value) => {
        const updated = [...gradeRows];

        if (field === "scoreGrade") {

            // Allow digits, decimal, > and -
            if (!/^[0-9>.-]*$/.test(value)) {
                return;
            }

            updated[rowIndex].scoreGrade = value;

            // User is temporarily clearing the field
            if (value.trim() === "") {
                updated[rowIndex].min = "";
                updated[rowIndex].max = "";

                setGradeRows(updated);
                return;
            }

            // Extract numbers
            const nums =
                value.match(/\d+(?:\.\d+)?/g)?.map(Number) || [];

            let newMin;
            let newMax;

            if (value.startsWith(">")) {
                newMin = nums[0] ?? "";
                newMax = nums[1] ?? 100;
            } else {
                newMin = nums[0] ?? "";
                newMax = nums[1] ?? nums[0] ?? "";
            }

            if (newMax !== "" && Number(newMax) > 100) {
                newMax = 100;
            }

            updated[rowIndex].min = newMin;
            updated[rowIndex].max = newMax;

            // ---------------------------------------
            // PROPAGATE CHANGES TO FOLLOWING ROWS
            // ---------------------------------------

            if (
                newMax !== "" &&
                !Number.isNaN(Number(newMax))
            ) {

                let previousMax = Number(newMax);

                for (
                    let i = rowIndex + 1;
                    i < updated.length;
                    i++
                ) {

                    const currentGrade =
                        String(updated[i].scoreGrade || "").trim();

                    // If row is empty, stop propagation
                    if (!currentGrade) {
                        break;
                    }

                    const currentNums =
                        currentGrade
                            .match(/\d+(?:\.\d+)?/g)
                            ?.map(Number) || [];

                    const oldMin =
                        currentNums.length > 0
                            ? currentNums[0]
                            : previousMax;

                    const oldMax =
                        currentNums.length > 1
                            ? currentNums[1]
                            : null;

                    // --------------------------------
                    // LAST ROW
                    // --------------------------------

                    if (i === updated.length - 1) {
                        updated[i].min = previousMax;
                        updated[i].max = 100;
                        updated[i].scoreGrade =
                            `>${previousMax}-100`;
                        break;
                    }

                    // --------------------------------
                    // PRESERVE THE OLD RANGE WIDTH
                    // --------------------------------

                    let rangeWidth = 1;

                    if (
                        oldMax !== null &&
                        !Number.isNaN(oldMax) &&
                        !Number.isNaN(oldMin)
                    ) {
                        rangeWidth = oldMax - oldMin;
                    }

                    // Safety: minimum increase should be 1
                    if (rangeWidth <= 0) {
                        rangeWidth = 1;
                    }

                    // New maximum is based on the NEW previous maximum
                    let nextMax = Math.ceil(previousMax + rangeWidth);

                    if (nextMax > 100) {
                        nextMax = 100;
                    }
                    // --------------------------------
                    // UPDATE CURRENT ROW
                    // --------------------------------

                    updated[i].min = previousMax;
                    updated[i].max = nextMax;

                    updated[i].scoreGrade =
                        `>${previousMax}-${nextMax}`;

                    // This becomes the starting point
                    // for the next row
                    previousMax = nextMax;
                }
            }
        }

        else if (field === "percentage") {

            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }

            updated[rowIndex].percentageDisplay = value;

            updated[rowIndex].percentage =
                value === ""
                    ? ""
                    : Number(value) / 100;
        }

        setGradeRows(updated);
    };

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => sum + (Number(row.applicablePercentage) || 0),
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) * totalApplicablePercentage
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };

    const displayedQuarterHeaders = getQuarterSequence(reportingDate);

    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    const sortQuarter = (a, b) => {

        const [qa, ya] = a.split("-");
        const [qb, yb] = b.split("-");

        const yearA = Number(ya);
        const yearB = Number(yb);

        if (yearA !== yearB) {
            return yearA - yearB;
        }

        return Number(qa.replace("Q", "")) - Number(qb.replace("Q", ""));
    };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeForShariahRisk;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const isWeightValid = Math.abs(totalWeight - 1) <= 0.000001;

    const areWeightsFilled = indexRows.every(
        row => row.weightDisplay !== ""
    );

    const areScoreGradesFilled = gradeRows.every(
        row => row.scoreGrade.trim() !== ""
    );

    const arePercentagesFilled = gradeRows.every(
        row => row.percentageDisplay !== ""
    );

    const isSubmitEnabled =
        reportingDate !== "";

    const formatPercentTwoDecimal = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(2)}%`;
    };

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null) return "";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        return `${(Number(value || 0) * 100).toFixed(2)}%`;
    };

    const formatIndex = (value) => {
        if (value === "" || value == null) return "";

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
    };

    const formatNumber = (value) => {
        if (value === "\\N" || value === null || value === undefined || value === "") {
            return "";
        }

        const number = Number(value);

        if (isNaN(number)) {
            return value;
        }

        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };



    const handleReset = async () => {
        // Restore original Excel rows and merged cells
        await loadExcel();

        // Remove unsaved added rows and sections
        setNewComplaintSections([]);
        setNewAverageRows([]);

        // Clear Excel and Average Score edit modes
        setEditingExcelRows({});
        setEditingAverageRows({});

        // Reset form and validation states
        setSelectedCustomerType("");
        setAllowSubmit(false);
        setWeightError("");

        // Restore original index rows
        setIndexRows(
            initialIndexRows.map((row) => ({
                ...row,
                isEditing: false,
            }))
        );

        // Restore original grade rows
        setGradeRows(
            initialGradeRows.map((row) => ({
                ...row,
            }))
        );
    };


    const getReportingDate = (quarter) => {
        if (!quarter) return "";

        const [q, year] = quarter.split("-");

        switch (q) {
            case "Q1":
                return `${year}-03-31`;
            case "Q2":
                return `${year}-06-30`;
            case "Q3":
                return `${year}-09-30`;
            case "Q4":
                return `${year}-12-31`;
            default:
                return "";
        }
    };

    const generateTxtData = () => {
        const reportDate = getReportingDate(reportingDate);

        const lines = [];

        const particulars = sheetData.riskMeasurement.particularsRows;

        for (let i = 0; i < indexRows.length; i++) {

            const idx = indexRows[i];
            const grade = calculatedGradeRows[i] || {};

            let particularLabel = "";
            let particularValue = "";

            let quarter1 = "\\N";
            let quarter2 = "\\N";
            let quarter3 = "\\N";
            let quarter4 = "\\N";
            let average = "\\N";

            // First three Particular rows only
            if (i === 0) {
                particularLabel = particulars[0]?.label || "";
                particularValue = operationalRiskCharge;

                quarter1 = q1 || "\\N";
                quarter2 = q2 || "\\N";
                quarter3 = q3 || "\\N";
                quarter4 = q4 || "\\N";
                average = finalCapitalCharge || "\\N";
            }
            else if (i === 1) {
                particularLabel = particulars[1]?.label || "";
                particularValue = formatApplicablePercent(totalApplicablePercentage);
            }
            else if (i === 2) {
                particularLabel = particulars[2]?.label || "";
                particularValue = capitalChargeForShariahRisk;
            }

            lines.push([
                reportDate,
                idx.keyArea,
                formatPercent(idx.weight),
                idx.observations || "",
                idx.impact || "",
                Number(idx.index).toFixed(2),
                grade.scoreGrade || "",
                grade.min ?? "\\N",
                grade.max ?? "\\N",
                grade.percentage ? formatExcelPercent(grade.percentage) : "",
                formatApplicablePercent(grade.applicablePercentage),
                particularLabel,
                particularValue,
                quarter1,
                quarter2,
                quarter3,
                quarter4,
                average
            ].join("|"));
        }

        // Total Row
        lines.push([
            reportDate,
            "Total",
            // "",
            formatPercent(totalWeight),
            "",
            "",
            Number(totalIndex).toFixed(2),
            "",
            "\\N",
            "\\N",
            "",
            "",
            "",
            "",
            "\\N",
            "\\N",
            "\\N",
            "\\N",
            "\\N"
        ].join("|"));

        return lines.join("\n");
    };

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };


    const handleSubmit = async () => {
        try {
            setLoading(true);

            const selectedReportDate = availableReportingDates?.[0] || "";

            const reportDate = selectedReportDate
                ? getFinancialYear(selectedReportDate)
                : "";

            if (!reportDate) {
                throw new Error("Reporting date is missing.");
            }

            console.log("Selected reporting date:", selectedReportDate);
            console.log("Reporting date in JSON:", reportDate);

            const userId = localStorage.getItem("userid");
            const filename = `${userId}_Bsf_Complaints.json`;

            const getValue = (value) =>
                String(value ?? "")
                    .replace(/\r?\n/g, " ")
                    .trim()
                    .replace(/\s+/g, " ");

            const formatThreshold = (value) => {
                const formattedValue = getValue(value);

                if (
                    formattedValue &&
                    !formattedValue.endsWith("%") &&
                    !isNaN(Number(formattedValue))
                ) {
                    return `${formattedValue}`;
                }

                return formattedValue;
            };

            const sourceStartIndex =
                headerRowIndex !== -1 ? headerRowIndex + 1 : 0;

            const sourceEndIndex =
                averageRowIndex === -1
                    ? excelRows.length
                    : averageRowIndex;

            const sourceRows = excelRows.slice(
                sourceStartIndex,
                sourceEndIndex
            );

            // Keep each row's original position so newly added sections
            // can be placed in the same order as the displayed table.
            const orderedRows = [];

            let currentCustomerType = "";
            let currentSerialNo = "";
            let currentParameter = "";

            sourceRows.forEach((row, index) => {
                const customerType = getValue(row[0]);
                const serialNo = getValue(row[1]);
                const parameter = getValue(row[2]);

                const from = getValue(row[3]);
                const to = getValue(row[4]);
                const score = getValue(row[5]);

                if (customerType) currentCustomerType = customerType;
                if (serialNo) currentSerialNo = serialNo;
                if (parameter) currentParameter = parameter;

                // Skip the From / To / Score header row.
                if (
                    from.toLowerCase() === "from" &&
                    to.toLowerCase() === "to" &&
                    score.toLowerCase() === "score"
                ) {
                    return;
                }

                // Skip rows without threshold data.
                if (!from && !to && !score) {
                    return;
                }

                orderedRows.push({
                    order: sourceStartIndex + index,
                    priority: 1,
                    sequence: index,
                    customer_type: currentCustomerType,
                    s_no: Number(currentSerialNo) || 1,
                    parameters: currentParameter,
                    from_threshold: from,
                    to_threshold: formatThreshold(to),
                    score_threshold: score,
                });
            });

            // Add dynamically created sections at their displayed positions.
            newComplaintSections.forEach((section, sectionIndex) => {
                let sectionSerialNo = "";
                let sectionParameter = "";

                section.rows.forEach((row, rowIndex) => {
                    const serialNo = getValue(row[1]);
                    const parameter = getValue(row[2]);

                    const from = getValue(row[3]);
                    const to = getValue(row[4]);
                    const score = getValue(row[5]);

                    if (serialNo) sectionSerialNo = serialNo;
                    if (parameter) sectionParameter = parameter;

                    // Skip the From / To / Score header row.
                    if (
                        from.toLowerCase() === "from" &&
                        to.toLowerCase() === "to" &&
                        score.toLowerCase() === "score"
                    ) {
                        return;
                    }

                    // Skip rows without threshold data.
                    if (!from && !to && !score) {
                        return;
                    }

                    orderedRows.push({
                        order: section.insertBeforeRow,
                        priority: 0,
                        sequence: sectionIndex * 100000 + rowIndex,
                        customer_type: getValue(section.customerType),
                        s_no: Number(sectionSerialNo) || 1,
                        parameters: sectionParameter,
                        from_threshold: from,
                        to_threshold: formatThreshold(to),
                        score_threshold: score,
                    });
                });
            });

            // Restore the order shown in the UI.
            // Newly added sections come before the original row they precede.
            orderedRows.sort(
                (a, b) =>
                    a.order - b.order ||
                    a.priority - b.priority ||
                    a.sequence - b.sequence
            );

            // Recalculate Sr. No once per consecutive parameter group.
            let nextSerialNo = 0;
            let previousGroup = "";

            const allRows = orderedRows.map((row) => {
                const groupKey =
                    `${row.customer_type.trim()}||${row.parameters.trim()}`;

                if (groupKey !== previousGroup) {
                    nextSerialNo++;
                    previousGroup = groupKey;
                }

                return {
                    customer_type: row.customer_type,
                    s_no: nextSerialNo,
                    parameters: row.parameters,
                    from_threshold: row.from_threshold,
                    to_threshold: row.to_threshold,
                    score_threshold: row.score_threshold,
                };
            });

            // Extract Rating / Average Score values, skipping headers.
            const ratingRows =
                averageRowIndex !== -1
                    ? excelRows
                        .slice(averageRowIndex + 1)
                        .filter((row) => {
                            const score = getValue(row[3]);
                            const rating = getValue(row[4]);
                            const average = getValue(row[5]);

                            return (
                                !(
                                    score.toLowerCase() === "score" &&
                                    rating.toLowerCase() === "rating" &&
                                    average.toLowerCase() === "average score"
                                ) &&
                                (score || rating || average)
                            );
                        })
                        .map((row) => ({
                            score: getValue(row[3]),
                            rating: getValue(row[4]),
                            average_score: getValue(row[5]),
                        }))
                    : [];

            // Create the final flat JSON array.
            const submitJson = allRows.map((row, index) => {
                const rating = ratingRows[index] || {};

                return {
                    template_name: "leadership_thresholds",
                    reporting_date: reportDate,
                    customer_type: row.customer_type,
                    sr_no: row.s_no,
                    parameters: row.parameters,
                    from_threshold: row.from_threshold,
                    to_threshold: row.to_threshold,
                    score_threshold: row.score_threshold,
                    section: rating.score || "",
                    rating: rating.rating || "",
                    average_score: rating.average_score || "",
                };
            });

            console.log("Generated JSON:", submitJson);

            // Save JSON.
            const saveResponse = await axios.post(
                createTextFileApi,
                {
                    filename,
                    content: JSON.stringify(submitJson, null, 2),
                },
                {
                    headers: {
                        userId,
                        "x-csrf-token": csrfToken,
                    },
                    withCredentials: true,
                }
            );

            console.log(`${filename} updated successfully`);

            // Call existing API only after JSON is saved successfully.
            if (saveResponse.status === 200) {
                const config = {
                    headers: {
                        userId,
                        "x-csrf-token": csrfToken,
                    },
                    withCredentials: true,
                    params: {
                        userId: userId,
                        tableName: "leadership_thresholds",
                        Notifications: "IN",
                        dept: department,
                        filePath: `/saswork/nas/${filename}`,
                    },
                };

                const response = await axios.post(
                    complaintsconfig,
                    {},
                    config
                );

                console.log(
                    "Complaints Mapping API Response:",
                    response.data
                );

                if (
                    response.status === 200 &&
                    (
                        response.data?.status === "success" ||
                        response.data?.status === "SUCCESS"
                    )
                ) {
                    setMessageType("success");
                    setModalMessage(
                        "Mapping Data submitted successfully."
                    );
                    setShowModal(true);
                }
            }
        } catch (error) {
            console.error("Submit Error:", error);
        } finally {
            setLoading(false);
        }
    };


    const callAdditionalApi = async (
        fileName,
        filePath,
        notifyType = "IN",
        errorData = "N",
        errorFileName = ""
    ) => {
        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: fileName.replace(".txt", ""),
                    recordsCount: 0,
                    Notifications: "IN",
                    filePath: filePath,
                    dataModel: "BDM",
                    templateType: "bulkupload",
                    keyValidation: "Y",
                    colValidation: "N",
                    dept: department,
                    allowModify: " ",
                    Maker_Remarks: "",
                    allowUpload: "N"
                }
            };

            const response = await axios.post(
                Bulkuploaddata,
                {},
                config
            );

            console.log("Additional API Response:", response.data);

            if (response.data?.active_status && response.data?.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);
            }

            if (response.data?.status === "success") {

                const userId = localStorage.getItem("userid");

                const statusJsonFile = `${userId}_complaints.json`;

                // Read existing JSON if available
                let existingData = [];

                try {
                    const response = await fetch(`/jsonfiles/${statusJsonFile}`);

                    if (response.ok) {
                        existingData = await response.json();
                    }
                } catch (err) {
                    console.log("Status file doesn't exist. Creating new file.");
                }

                // New status object
                const newStatus = {
                    reporting_date: getReportingDate(reportingDate),
                    submitted_date: new Date().toISOString().split("T")[0],
                    status: "Pending for Checker Review",
                    reported_by: "10192",
                    reviewed_by: "10007",
                    submitted_remarks: inputValue,
                    tableName: fileName.replace(".txt", "")
                };

                // Check whether this reporting date already exists
                // Find existing record with the same reporting date
                const index = existingData.findIndex(
                    item => item.reporting_date === newStatus.reporting_date
                );

                if (index !== -1) {
                    // Remove the old record for this reporting date
                    existingData.splice(index, 1);
                }

                // Always insert the latest version at the beginning
                existingData.unshift(newStatus);

                const statusContent = JSON.stringify(existingData, null, 2);

                // Save updated JSON
                await axios.post(
                    updatetextfile3001,
                    {
                        tableNameWithJson: statusJsonFile,
                        content: statusContent
                    },
                    {
                        headers: {
                            userId,
                            "x-csrf-token": csrfToken
                        },
                        withCredentials: true
                    }
                );

                // Success
                setMessageType("success");
                setModalMessage("Data Submitted Successfully");
                setShowModal(true);

                await fetchPreviewData();

                handleReset();
            } else {

                setMessageType("warning");
                setModalMessage(response.data?.message || "Upload Failed");
                setShowModal(true);
                // setrecordSuccess("N");
            }

        } catch (error) {

            console.log("ERROR OBJECT:", error);
            console.log("ERROR RESPONSE:", error.response);
            console.log("ERROR MESSAGE:", error.message);
            console.log("ERROR STACK:", error.stack);

            setShowNotifyModal(false);
            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while processing uploaded file."
            );
            setShowModal(true);
        }
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };

    const excelTitle = excelRows
        .flat()
        .find(
            (cell) =>
                String(cell).trim().toLowerCase() ===
                "leadership"
        );


    const normalizeThreshold = (value) =>
        String(value ?? "").trim().replace(/\s/g, "").toUpperCase();

    const isSpecialThreshold = (value) =>
        ["~", "100+"].includes(normalizeThreshold(value));

    const isValidThreshold = (value) => {
        const v = normalizeThreshold(value);

        // Allow temporary empty input while editing.
        if (v === "") return true;

        // Special threshold values.
        if (v === "~" || v === "100+") return true;

        // Numbers only, optionally followed by %.
        if (!/^\d+(?:\.\d*)?%?$/.test(v)) return false;

        const number = Number(v.replace("%", ""));

        return Number.isFinite(number) && number >= 0 && number <= 100;
    };

    const isValidScore = (value) =>
        /^\d*$/.test(String(value ?? "").trim());

    const getNextFromValue = (toValue) => {
        const value = normalizeThreshold(toValue);

        if (value === "100" || value === "100") {
            return "100+";
        }

        if (value === "100+") {
            return "~";
        }

        if (value === "~") {
            return "~";
        }

        const match = value.match(/^(\d+(?:\.\d*)?|\.\d+)%?$/);

        if (!match) return null;

        return `${Number(match[1])}`;
    };



    const handleAddComplaintSectionRow = (sectionId, rowIndex) => {
        const insertAt = rowIndex + 1;

        setNewComplaintSections((prev) =>
            prev.map((section) => {
                if (section.id !== sectionId) return section;

                const sourceRow = section.rows[rowIndex];
                if (!sourceRow) return section;

                // Insert a blank threshold row.
                const newRow = sourceRow.map(() => "");
                newRow[2] = null; // Parameter stays display-only.
                newRow[3] = "";
                newRow[4] = "";
                newRow[5] = "";

                const rows = section.rows.map((row) => [...row]);
                rows.splice(insertAt, 0, newRow);

                // Update merged-cell coordinates.
                const merges = section.merges.map((merge) => {
                    const updated = {
                        s: { ...merge.s },
                        e: { ...merge.e },
                    };

                    if (
                        updated.s.r <= rowIndex &&
                        updated.e.r >= rowIndex
                    ) {
                        // Extend merges containing the selected row.
                        updated.e.r++;
                    } else if (updated.s.r >= insertAt) {
                        // Shift merges located below the inserted row.
                        updated.s.r++;
                        updated.e.r++;
                    }

                    return updated;
                });

                return {
                    ...section,
                    rows,
                    merges,
                };
            })
        );
    };


    const handleDeleteComplaintSectionRow = (sectionId, rowIndex) => {
        setNewComplaintSections((prev) =>
            prev.flatMap((section) => {
                if (section.id !== sectionId) return [section];

                const headerIndex = section.rows.findIndex(
                    (row) =>
                        String(row[3] ?? "").trim().toLowerCase() === "from" &&
                        String(row[4] ?? "").trim().toLowerCase() === "to" &&
                        String(row[5] ?? "").trim().toLowerCase() === "score"
                );

                const thresholdRowsCount =
                    headerIndex >= 0
                        ? section.rows.length - headerIndex - 1
                        : 0;

                // Deleting the last threshold row removes the entire section
                if (thresholdRowsCount <= 1) {
                    return [];
                }

                // Otherwise, remove only the selected row
                const rows = section.rows.filter(
                    (_, index) => index !== rowIndex
                );

                // Adjust merged-cell ranges after deleting the row
                const merges = section.merges
                    .filter((merge) => {
                        return !(
                            merge.s.r === rowIndex &&
                            merge.e.r === rowIndex
                        );
                    })
                    .map((merge) => {
                        const updated = {
                            s: { ...merge.s },
                            e: { ...merge.e },
                        };

                        if (updated.s.r > rowIndex) {
                            updated.s.r--;
                            updated.e.r--;
                        } else if (
                            updated.s.r < rowIndex &&
                            updated.e.r >= rowIndex
                        ) {
                            updated.e.r--;
                        }

                        return updated;
                    });

                return [{ ...section, rows, merges }];
            })
        );
    };

    const renderNewSection = (section) => {
        const isSelected = selectedNewSectionId === section.id;

        return (
            <React.Fragment key={section.id}>
                {section.rows.map((row, rowIndex) => {
                    const isThresholdHeader = [
                        "from",
                        "to",
                        "score"
                    ].includes(
                        String(row[3] ?? "").trim().toLowerCase()
                    );

                    const isEditing = isSelected && isNewSectionEditing;

                    return (
                        <tr key={`${section.id}-${rowIndex}`}>
                            {row.map((cell, colIndex) => {
                                if (colIndex === 0) return null;

                                const merge = section.merges.find(
                                    (m) =>
                                        m.s.r === rowIndex &&
                                        m.s.c === colIndex
                                );

                                const isMergedContinuation =
                                    section.merges.some(
                                        (m) =>
                                            rowIndex >= m.s.r &&
                                            rowIndex <= m.e.r &&
                                            colIndex >= m.s.c &&
                                            colIndex <= m.e.c &&
                                            (rowIndex !== m.s.r ||
                                                colIndex !== m.s.c)
                                    );

                                if (isMergedContinuation) return null;

                                const editable =
                                    isEditing &&
                                    [2, 3, 4, 5].includes(colIndex) &&
                                    (rowIndex > 0 || colIndex === 2);

                                return (
                                    <td
                                        key={colIndex}
                                        rowSpan={
                                            merge
                                                ? merge.e.r - merge.s.r + 1
                                                : undefined
                                        }
                                        colSpan={
                                            merge
                                                ? merge.e.c - merge.s.c + 1
                                                : undefined
                                        }
                                        style={{
                                            whiteSpace: "pre-line",
                                            overflowWrap: "break-word",
                                            verticalAlign: "middle",
                                            textAlign: merge ? "center" : "left",
                                            ...(colIndex === 2 ? PARAM_COL_STYLE : {}),
                                            fontWeight: isThresholdHeader
                                                ? "bold"
                                                : "normal"
                                        }}
                                    >
                                        {editable ? (
                                            <div className="input-group input-group-sm">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    inputMode="text"
                                                    value={cell ?? ""}
                                                    placeholder={
                                                        colIndex === 3
                                                            ? "From"
                                                            : colIndex === 4
                                                                ? "To"
                                                                : colIndex === 5
                                                                    ? "Score"
                                                                    : ""
                                                    }
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (
                                                            [3, 4].includes(colIndex) &&
                                                            !isValidThreshold(value)
                                                        ) {
                                                            return;
                                                        }

                                                        if (
                                                            colIndex === 5 &&
                                                            !isValidScore(value)
                                                        ) {
                                                            return;
                                                        }

                                                        updateComplaintCell(
                                                            section.id,
                                                            rowIndex,
                                                            colIndex,
                                                            value
                                                        );
                                                    }}
                                                />

                                                {[3, 4].includes(colIndex) &&
                                                    !isSpecialThreshold(cell) &&
                                                    !String(cell ?? "").includes("%") && (
                                                        <span className="input-group-text"></span>
                                                    )}
                                            </div>
                                        ) : (
                                            cell
                                        )}
                                    </td>
                                );
                            })}

                            {/* Actions column */}
                            {isSelected ? (
                                <td
                                    className="text-center"
                                    style={{
                                        width: "42px",
                                        minWidth: "42px",
                                        maxWidth: "42px",
                                        verticalAlign: "middle",
                                        padding: "3px 2px"
                                    }}
                                >
                                    {!isThresholdHeader && (
                                        <button
                                            type="button"
                                            title="Delete row"
                                            aria-label="Delete row"
                                            onClick={() =>
                                                handleDeleteComplaintSectionRow(
                                                    section.id,
                                                    rowIndex
                                                )
                                            }
                                            style={{
                                                width: "26px",
                                                height: "26px",
                                                border: "none",
                                                background: "transparent",
                                                color: "#000",
                                                padding: 0,
                                                cursor: "pointer"
                                            }}
                                        >
                                            <i
                                                className="bi bi-trash3"
                                                style={{ fontSize: "14px" }}
                                            />
                                        </button>
                                    )}
                                </td>
                            ) : (
                                rowIndex === 0 && (
                                    <td
                                        rowSpan={section.rows.length}
                                        className="text-center"
                                        style={{
                                            width: "42px",
                                            minWidth: "42px",
                                            maxWidth: "42px",
                                            verticalAlign: "middle",
                                            padding: "3px 2px"
                                        }}
                                    >
                                        <button
                                            type="button"
                                            title="Select parameter"
                                            onClick={() => {
                                                setSelectedGroup(null);
                                                setSelectedNewSectionId(section.id);
                                                setIsNewSectionEditing(false);
                                            }}
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                color: "#000",
                                                padding: 0,
                                                cursor: "pointer"
                                            }}
                                        >
                                            <i
                                                className={
                                                    selectedNewSectionId === section.id
                                                        ? "bi bi-check-square-fill"
                                                        : "bi bi-square"
                                                }
                                                style={{ fontSize: "15px", color: "#000" }}
                                            />
                                        </button>
                                    </td>
                                )
                            )}
                        </tr>
                    );
                })}
            </React.Fragment>
        );
    };

    const normalizeCustomerType = (value) =>
        String(value ?? "")
            .replace(/[\r\n]+/g, " ")
            .replace(/\s*-\s*/g, "-")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

    const nonRetailStartRow = excelRows.findIndex((row) =>
        row.some(
            (cell) =>
                normalizeCustomerType(cell) === "non-retail customers"
        )
    );

    const retailAddedCount = newComplaintSections.filter(
        (section) =>
            normalizeCustomerType(section.customerType) === "retail customers"
    ).length;



    const updateComplaintCell = (
        sectionId,
        rowIndex,
        colIndex,
        value
    ) => {
        setNewComplaintSections((prev) =>
            prev.map((section) => {
                if (section.id !== sectionId) return section;

                const rows = section.rows.map((row) => [...row]);

                // Update the edited cell.
                rows[rowIndex][colIndex] = value;

                // Only calculate the next row's From value when
                // the To value is numeric or a supported special value.
                if (colIndex === 4) {
                    const normalizedTo = normalizeThreshold(value);

                    const isProgressionValue =
                        normalizedTo === "100" ||
                        normalizedTo === "100+" ||
                        normalizedTo === "~" ||
                        /^\d+(?:\.\d+)?%?$/.test(normalizedTo);

                    if (!isProgressionValue) {
                        return { ...section, rows };
                    }

                    const isDataRow = (row) => {
                        const from = String(row[3] ?? "").trim().toLowerCase();
                        const to = String(row[4] ?? "").trim().toLowerCase();
                        const score = String(row[5] ?? "").trim().toLowerCase();

                        return (
                            from !== "from" &&
                            to !== "to" &&
                            score !== "score"
                        );
                    };

                    const nextRowIndex = rows.findIndex(
                        (row, index) =>
                            index > rowIndex && isDataRow(row)
                    );

                    if (nextRowIndex !== -1) {
                        if (normalizedTo === "100") {
                            rows[nextRowIndex][3] = "100+";
                            rows[nextRowIndex][4] = "~";
                        } else if (
                            normalizedTo === "100+" ||
                            normalizedTo === "~"
                        ) {
                            rows[nextRowIndex][3] = "~";
                        } else {
                            const nextFrom = getNextFromValue(value);

                            if (nextFrom !== null) {
                                rows[nextRowIndex][3] = nextFrom;
                            }
                        }

                    }
                }

                return {
                    ...section,
                    rows,
                };
            })
        );
    };

    const actionButtonStyle = {
        width: "29px",
        height: "29px",
        borderRadius: "6px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        fontSize: "14px"
    };



    // const updateComplaintCell = (sectionId, rowIndex, colIndex, value) => {
    //     setNewComplaintSections((prev) =>
    //         prev.map((section) => {
    //             if (section.id !== sectionId) return section;

    //             return {
    //                 ...section,
    //                 rows: section.rows.map((row, r) =>
    //                     r !== rowIndex
    //                         ? row
    //                         : row.map((cell, c) =>
    //                             c === colIndex ? value : cell
    //                         )
    //                 ),
    //             };
    //         })
    //     );
    // };


    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid my-1">
                        <div className="row">

                            {loading && (
                                <div className="loading-overlay">
                                    <UploadLoadingIcon />
                                </div>
                            )}

                            {!loading && excelRows.length === 0 ? (
                                <div className="card">
                                    <div className="card-body text-center">
                                        No Data Found
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="card-header bg-primary text-white">
                                        <h5 className="mb-0">
                                            {"Leadership"}
                                        </h5>
                                    </div>
                                    <div className="row g-2">
                                        <div className="col-lg-4 col-md-12">
                                            <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                <div className="card-body">
                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                        <div className="">
                                                            <GapsyShariahDescription />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* ── RIGHT col: tables ── */}
                                        <div className="col-lg-8 col-md-12">
                                            <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                {/* <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}> */}

                                                <div className="card-body">
                                                    {loading ? (
                                                        <div>Loading Excel...</div>
                                                    ) : excelRows.length === 0 ? (
                                                        <div className="text-center">No Data Found</div>

                                                    ) : (
                                                        <>

                                                            {excelTitle && (

                                                                <div className="px-2 pt-2 mb-3">
                                                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                                        {modifiedOn && (
                                                                            <div className={tableStyles.lastUpdatedBadge}>
                                                                                <i className="bi bi-clock-history" />
                                                                                <span>
                                                                                    Last Updated on {modifiedOn}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <label
                                                                                htmlFor="reportingDate"
                                                                                className="fw-semibold mb-0 text-nowrap"
                                                                            >
                                                                                Reporting Date

                                                                            </label>
                                                                            <input
                                                                                id="reportingDate"
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                style={{ width: "110px" }}
                                                                                value={availableReportingDates[0] || ""}
                                                                                // value={
                                                                                //     availableReportingDates[0]
                                                                                //         ? getFinancialYear(availableReportingDates[0])
                                                                                //         : ""
                                                                                // }
                                                                                readOnly

                                                                            />


                                                                            <div
                                                                                className="d-flex flex-column align-items-end gap-1 flex-shrink-0"
                                                                                style={{ width: "110px" }}
                                                                            >
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-primary"
                                                                                    style={{ whiteSpace: "nowrap" }}
                                                                                    onClick={() => handleAddNewRow("Non-Retail Customers")}
                                                                                >
                                                                                    <i className="bi bi-plus-circle me-1" />
                                                                                    Add New
                                                                                </button>


                                                                            </div>
                                                                            {(selectedGroup !== null || selectedNewSectionId !== null) && (
                                                                                <div className="d-flex justify-content-end gap-1 w-100">

                                                                                    {/* Add Row */}
                                                                                    <button
                                                                                        type="button"
                                                                                        title="Add row"
                                                                                        className="btn btn-outline-success"
                                                                                        style={actionButtonStyle}
                                                                                        onClick={() => {
                                                                                            if (selectedNewSectionId !== null) {
                                                                                                const section = newComplaintSections.find(
                                                                                                    (s) => s.id === selectedNewSectionId
                                                                                                );

                                                                                                if (section) {
                                                                                                    const lastDataRowIndex = section.rows.reduce(
                                                                                                        (last, row, index) =>
                                                                                                            ["from", "to", "score"].includes(
                                                                                                                String(row[3] ?? "").trim().toLowerCase()
                                                                                                            )
                                                                                                                ? last
                                                                                                                : index,
                                                                                                        -1
                                                                                                    );

                                                                                                    handleAddComplaintSectionRow(
                                                                                                        section.id,
                                                                                                        lastDataRowIndex
                                                                                                    );
                                                                                                }
                                                                                            } else {
                                                                                                handleAddExcelRow(
                                                                                                    selectedRows[selectedRows.length - 1]
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <i className="bi bi-plus-circle" />
                                                                                    </button>

                                                                                    {/* Edit / Save */}
                                                                                    {(
                                                                                        selectedNewSectionId !== null
                                                                                            ? isNewSectionEditing
                                                                                            : isSelectedEditing
                                                                                    ) ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success"
                                                                                            title="Save"
                                                                                            style={actionButtonStyle}
                                                                                            onClick={() => {
                                                                                                if (selectedNewSectionId !== null) {
                                                                                                    setIsNewSectionEditing(false);
                                                                                                    newSectionBackup.current = null;
                                                                                                    setSelectedNewSectionId(null);
                                                                                                } else {
                                                                                                    selectedRows.forEach((i) => handleSaveExcelRow(i));

                                                                                                    excelRowsBackup.current = null;
                                                                                                    setEditingExcelRows({});
                                                                                                    setSelectedGroup(null);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-check-circle" />
                                                                                        </button>
                                                                                    ) : (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-outline-primary"
                                                                                            title="Edit"
                                                                                            style={actionButtonStyle}
                                                                                            onClick={() => {
                                                                                                if (selectedNewSectionId !== null) {
                                                                                                    newSectionBackup.current = structuredClone(
                                                                                                        newComplaintSections
                                                                                                    );
                                                                                                    setIsNewSectionEditing(true);
                                                                                                } else {
                                                                                                    excelRowsBackup.current = structuredClone(excelRows);
                                                                                                    selectedRows.forEach((i) =>
                                                                                                        handleEditExcelRow(i)
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-pencil-square" />
                                                                                        </button>
                                                                                    )}

                                                                                    {/* Deselect */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-secondary"
                                                                                        title="Deselect"
                                                                                        style={actionButtonStyle}
                                                                                        onClick={() => {
                                                                                            if (selectedNewSectionId !== null) {
                                                                                                if (newSectionBackup.current) {
                                                                                                    setNewComplaintSections(
                                                                                                        newSectionBackup.current
                                                                                                    );
                                                                                                }

                                                                                                newSectionBackup.current = null;
                                                                                                setIsNewSectionEditing(false);
                                                                                                setSelectedNewSectionId(null);
                                                                                            } else {
                                                                                                if (excelRowsBackup.current) {
                                                                                                    setExcelRows(excelRowsBackup.current);
                                                                                                }

                                                                                                excelRowsBackup.current = null;
                                                                                                setEditingExcelRows({});
                                                                                                setSelectedGroup(null);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <i className="bi bi-x-circle" />
                                                                                    </button>

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div
                                                                className={`tableWrapperNoBorder ${tableStyles.tableWrapperNoBorder}`}
                                                                style={{ maxHeight: "300px" }}
                                                            >
                                                                <div className="table-on-homepage-only">

                                                                    <table
                                                                        className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                                        style={{
                                                                            width: "100%",
                                                                            maxWidth: "100%",
                                                                            tableLayout: "fixed",
                                                                            marginBottom: 0
                                                                        }}
                                                                    >
                                                                        <colgroup>
                                                                            {excelRows[headerRowIndex]
                                                                                ?.slice(1)
                                                                                .map((_, index) => {
                                                                                    const colIndex = index + 1;

                                                                                    return (
                                                                                        <col
                                                                                            key={colIndex}
                                                                                            style={{
                                                                                                width:
                                                                                                    colIndex === 1 ? "50px" :
                                                                                                        colIndex === 2 ? "280px" :
                                                                                                            [3, 4].includes(colIndex) ? "100px" : // Min / Max
                                                                                                                colIndex === 5 ? "50px" :       // Score
                                                                                                                    "120px"
                                                                                            }}
                                                                                        />
                                                                                    );
                                                                                })}

                                                                            {/* Actions column */}
                                                                            <col style={{ width: "50px" }} />
                                                                        </colgroup>
                                                                        {/* Dynamic Table Header */}
                                                                        {headerRowIndex !== -1 && (

                                                                            <thead className="thead-light">

                                                                                <tr>

                                                                                    {excelRows[headerRowIndex].map(

                                                                                        (cell, colIndex) => {

                                                                                            if (colIndex === 0) return null;

                                                                                            const merge = excelMerges.find(

                                                                                                (m) =>

                                                                                                    m.s.r === headerRowIndex &&

                                                                                                    m.s.c === colIndex

                                                                                            );



                                                                                            const isMergedContinuation =

                                                                                                excelMerges.some(

                                                                                                    (m) =>

                                                                                                        headerRowIndex >= m.s.r &&

                                                                                                        headerRowIndex <= m.e.r &&

                                                                                                        colIndex >= m.s.c &&

                                                                                                        colIndex <= m.e.c &&

                                                                                                        (

                                                                                                            headerRowIndex !== m.s.r ||

                                                                                                            colIndex !== m.s.c

                                                                                                        )

                                                                                                );



                                                                                            if (isMergedContinuation) {

                                                                                                return null;

                                                                                            }



                                                                                            return (

                                                                                                <th

                                                                                                    key={colIndex}

                                                                                                    rowSpan={

                                                                                                        merge

                                                                                                            ? merge.e.r - merge.s.r + 1

                                                                                                            : undefined

                                                                                                    }

                                                                                                    colSpan={

                                                                                                        merge

                                                                                                            ? merge.e.c - merge.s.c + 1

                                                                                                            : undefined

                                                                                                    }

                                                                                                    style={{

                                                                                                        verticalAlign: "middle",

                                                                                                        textAlign: "center",

                                                                                                        whiteSpace: "pre-line",

                                                                                                        fontWeight: "bold"

                                                                                                    }}

                                                                                                >

                                                                                                    {cell}

                                                                                                </th>

                                                                                            );

                                                                                        }

                                                                                    )}

                                                                                    <th
                                                                                        className="text-center"
                                                                                        style={{
                                                                                            width: "42px",
                                                                                            minWidth: "42px",
                                                                                            maxWidth: "42px",
                                                                                            whiteSpace: "nowrap",
                                                                                            padding: "4px 2px"
                                                                                        }}
                                                                                    >
                                                                                        Actions
                                                                                    </th>

                                                                                </tr>

                                                                            </thead>

                                                                        )}



                                                                        {/* Table Body */}

                                                                        <tbody>

                                                                            {excelRows
                                                                                .slice(
                                                                                    headerRowIndex !== -1 ? headerRowIndex + 1 : 0,
                                                                                    averageRowIndex === -1 ? excelRows.length : averageRowIndex
                                                                                )
                                                                                .map((row, index) => {
                                                                                    const rowIndex =
                                                                                        headerRowIndex !== -1 ? headerRowIndex + 1 + index : index;

                                                                                    if (isEmptyThresholdRow(row, rowIndex)) {
                                                                                        return null;
                                                                                    }

                                                                                    // group info (merged Parameter cell)
                                                                                    const { groupStart, visibleRows } = getGroupRows(rowIndex);
                                                                                    const isFirstRowOfGroup = visibleRows[0] === rowIndex;
                                                                                    const showDelete =
                                                                                        !isThresholdHeaderRow(row) &&
                                                                                        (editingExcelRows[rowIndex] ||
                                                                                            [3, 4, 5].some((c) => String(row[c] ?? "").trim() !== ""));

                                                                                    return (
                                                                                        <React.Fragment key={`original-row-${rowIndex}`}>
                                                                                            {newComplaintSections
                                                                                                .filter((section) => section.insertBeforeRow === rowIndex)
                                                                                                .map(renderNewSection)}

                                                                                            <tr key={rowIndex}>
                                                                                                {row.map((cell, colIndex) => {
                                                                                                    if (colIndex === 0) return null;

                                                                                                    const merge = excelMerges.find(
                                                                                                        (m) => m.s.r === rowIndex && m.s.c === colIndex
                                                                                                    );

                                                                                                    const isMergedContinuation = excelMerges.some(
                                                                                                        (m) =>
                                                                                                            rowIndex >= m.s.r &&
                                                                                                            rowIndex <= m.e.r &&
                                                                                                            colIndex >= m.s.c &&
                                                                                                            colIndex <= m.e.c &&
                                                                                                            (rowIndex !== m.s.r || colIndex !== m.s.c)
                                                                                                    );

                                                                                                    if (isMergedContinuation) return null;

                                                                                                    const parameterMerge = excelMerges.find(
                                                                                                        (m) =>
                                                                                                            m.s.c === 2 &&
                                                                                                            m.e.c === 2 &&
                                                                                                            rowIndex >= m.s.r &&
                                                                                                            rowIndex <= m.e.r
                                                                                                    );

                                                                                                    const isEditing = !!editingExcelRows[rowIndex];

                                                                                                    return (
                                                                                                        <td
                                                                                                            key={colIndex}
                                                                                                            rowSpan={
                                                                                                                merge
                                                                                                                    ? excelRows
                                                                                                                        .slice(merge.s.r, merge.e.r + 1)
                                                                                                                        .filter(
                                                                                                                            (mergedRow, offset) =>
                                                                                                                                !isEmptyThresholdRow(
                                                                                                                                    mergedRow,
                                                                                                                                    merge.s.r + offset
                                                                                                                                )
                                                                                                                        ).length
                                                                                                                    : undefined
                                                                                                            }
                                                                                                            colSpan={merge ? merge.e.c - merge.s.c + 1 : undefined}
                                                                                                            style={{
                                                                                                                whiteSpace: "pre-line",
                                                                                                                overflowWrap: "break-word",
                                                                                                                verticalAlign: "middle",
                                                                                                                textAlign: merge ? "center" : "left",
                                                                                                                overflow: "hidden",
                                                                                                                boxSizing: "border-box",
                                                                                                                ...(colIndex === 2 ? PARAM_COL_STYLE : {}),
                                                                                                                fontWeight:
                                                                                                                    merge ||
                                                                                                                        ["from", "to", "score"].includes(
                                                                                                                            String(cell ?? "").trim().toLowerCase()
                                                                                                                        )
                                                                                                                        ? "bold"
                                                                                                                        : "normal",
                                                                                                            }}
                                                                                                        >
                                                                                                            {isEditing &&
                                                                                                                !["from", "to", "score"].includes(
                                                                                                                    String(cell ?? "").trim().toLowerCase()
                                                                                                                ) &&
                                                                                                                ([3, 4, 5].includes(colIndex) ||
                                                                                                                    (colIndex === 2 &&
                                                                                                                        parameterMerge &&
                                                                                                                        rowIndex === parameterMerge.s.r)) ? (
                                                                                                                <input
                                                                                                                    className={`form-control form-control-sm ${colIndex === 2
                                                                                                                        ? tableStyles.parameterInput
                                                                                                                        : tableStyles.compactInput
                                                                                                                        }`}
                                                                                                                    type="text"
                                                                                                                    value={cell ?? ""}
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        minWidth: 0,
                                                                                                                        maxWidth: "100%",
                                                                                                                        boxSizing: "border-box",
                                                                                                                        // padding: colIndex === 5 ? "2px 4px" : "4px 6px",
                                                                                                                        margin: 0
                                                                                                                    }}
                                                                                                                    onChange={(e) =>
                                                                                                                        handleExcelCellChange(
                                                                                                                            colIndex === 2 && parameterMerge
                                                                                                                                ? parameterMerge.s.r
                                                                                                                                : rowIndex,
                                                                                                                            colIndex,
                                                                                                                            e.target.value
                                                                                                                        )
                                                                                                                    }
                                                                                                                />

                                                                                                            ) : (
                                                                                                                colIndex === 1 &&
                                                                                                                    /^\d+$/.test(String(cell ?? "").trim()) &&
                                                                                                                    nonRetailStartRow !== -1 &&
                                                                                                                    rowIndex >= nonRetailStartRow
                                                                                                                    ? Number(cell) + retailAddedCount
                                                                                                                    : ["from", "to"].includes(
                                                                                                                        String(cell ?? "").trim().toLowerCase()
                                                                                                                    )
                                                                                                                        ? (
                                                                                                                            String(cell).trim().toLowerCase() === "from"
                                                                                                                                ? "Result Min"
                                                                                                                                : "Result Max"
                                                                                                                        )
                                                                                                                        : cell
                                                                                                            )}

                                                                                                        </td>
                                                                                                    );
                                                                                                })}

                                                                                                {/* Common checkbox: one per group, centered */}
                                                                                                {/* One Actions column:
    - group NOT selected -> checkbox (one per group, spans the group's rows)
    - group selected     -> checkbox hidden, small delete icon on each row of that group */}
                                                                                                {selectedGroup === groupStart ? (
                                                                                                    <td
                                                                                                        className="text-center"
                                                                                                        style={{
                                                                                                            width: "42px",
                                                                                                            minWidth: "42px",
                                                                                                            maxWidth: "42px",
                                                                                                            verticalAlign: "middle",
                                                                                                            textAlign: "center",
                                                                                                            padding: "3px 2px",
                                                                                                            boxSizing: "border-box",
                                                                                                            whiteSpace: "nowrap"
                                                                                                        }}
                                                                                                    >
                                                                                                        {showDelete && (
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-outline-danger"
                                                                                                                title="Delete row"
                                                                                                                aria-label="Delete row"
                                                                                                                onClick={() => {
                                                                                                                    // data rows of this group (excluding the Min/Max/Score heading row and blank rows)
                                                                                                                    const dataRows = visibleRows.filter(
                                                                                                                        (i) =>
                                                                                                                            !isThresholdHeaderRow(excelRows[i]) &&
                                                                                                                            [3, 4, 5].some((c) => String(excelRows[i][c] ?? "").trim() !== "")
                                                                                                                    );

                                                                                                                    handleDeleteExcelRow(rowIndex);

                                                                                                                    // Only clear the selection if the whole block is going away
                                                                                                                    // (the deleted row was the last data row). Otherwise keep it selected.
                                                                                                                    if (dataRows.length <= 1) {
                                                                                                                        setSelectedGroup(null);
                                                                                                                    }
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    width: "26px",
                                                                                                                    height: "26px",
                                                                                                                    border: "none",
                                                                                                                    background: "transparent",
                                                                                                                    color: "#000",
                                                                                                                    padding: 0,
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="bi bi-trash3" style={{ fontSize: "14px" }} />
                                                                                                            </button>

                                                                                                        )}
                                                                                                    </td>
                                                                                                ) : (
                                                                                                    isFirstRowOfGroup && (
                                                                                                        <td
                                                                                                            rowSpan={visibleRows.length}
                                                                                                            className="text-center"
                                                                                                            style={{
                                                                                                                width: "42px",
                                                                                                                minWidth: "42px",
                                                                                                                maxWidth: "42px",
                                                                                                                verticalAlign: "middle",
                                                                                                                textAlign: "center",
                                                                                                                padding: "3px 2px",
                                                                                                                boxSizing: "border-box",
                                                                                                                whiteSpace: "nowrap"
                                                                                                            }}
                                                                                                        >
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                title="Select parameter"
                                                                                                                onClick={() => {
                                                                                                                    setSelectedNewSectionId(null);
                                                                                                                    setIsNewSectionEditing(false);
                                                                                                                    toggleGroup(groupStart);
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    border: "none",
                                                                                                                    background: "transparent",
                                                                                                                    color: "#000",
                                                                                                                    padding: 0,
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                            >
                                                                                                                <i
                                                                                                                    className={
                                                                                                                        selectedGroup === groupStart
                                                                                                                            ? "bi bi-check-square-fill"
                                                                                                                            : "bi bi-square"
                                                                                                                    }
                                                                                                                    style={{ fontSize: "15px", color: "#000" }}
                                                                                                                />
                                                                                                            </button>
                                                                                                        </td>
                                                                                                    )
                                                                                                )}
                                                                                            </tr>
                                                                                        </React.Fragment>
                                                                                    );

                                                                                })}

                                                                            {newComplaintSections
                                                                                .filter(
                                                                                    (section) =>
                                                                                        section.insertBeforeRow ===
                                                                                        (averageRowIndex === -1
                                                                                            ? excelRows.length
                                                                                            : averageRowIndex)
                                                                                )
                                                                                .map(renderNewSection)}
                                                                        </tbody>
                                                                    </table>

                                                                    {/* Table 2: Rating and Average Score */}
                                                                    {averageRowIndex !== -1 && (
                                                                        <div className="p-3">
                                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                <h5 className="mb-0">Rating and Average Score</h5>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-success btn-sm"
                                                                                    onClick={handleAddAverageRow}
                                                                                >
                                                                                    <i className="bi bi-plus-circle me-1" />
                                                                                    Add Row
                                                                                </button>
                                                                            </div>

                                                                            <table
                                                                                className={`table table-bordered table-hover text-center mb-0 ${tableStyles.ratingTable} ${tableStyles.compactRows}`}
                                                                            >
                                                                                <colgroup>
                                                                                    <col style={{ width: "35%" }} /> {/* Section */}
                                                                                    <col style={{ width: "25%" }} /> {/* Rating */}
                                                                                    <col style={{ width: "25%" }} /> {/* Average Score */}
                                                                                    <col style={{ width: "15%" }} /> {/* Actions */}
                                                                                </colgroup>

                                                                                <thead >
                                                                                    <tr>
                                                                                        <th className={tableStyles.ratingTableHead}>Section</th>
                                                                                        <th className={tableStyles.ratingTableHead}>Rating</th>
                                                                                        <th className={tableStyles.ratingTableHead}>Average Score</th>
                                                                                        <th className={tableStyles.ratingTableHead}>Actions</th>
                                                                                    </tr>
                                                                                </thead>


                                                                                <tbody>
                                                                                    {/* Existing rating rows */}
                                                                                    {excelRows
                                                                                        .map((row, originalIndex) => ({
                                                                                            row,
                                                                                            originalIndex,
                                                                                        }))
                                                                                        .filter(({ originalIndex }) => originalIndex > averageRowIndex)
                                                                                        .map(({ row, originalIndex }, ratingIndex) => {
                                                                                            const ratingColor =
                                                                                                RATING_COLORS_BY_INDEX[ratingIndex] ||
                                                                                                NEW_RATING_COLOR;

                                                                                            return (
                                                                                                <tr key={`average-${originalIndex}`}>
                                                                                                    {/* Section */}
                                                                                                    <td>
                                                                                                        {editingAverageRows[originalIndex] ? (
                                                                                                            <input
                                                                                                                className={`form-control form-control-sm ${tableStyles.ratingInput}`}
                                                                                                                placeholder="Section"
                                                                                                                value={row[3] ?? ""}
                                                                                                                onChange={(e) =>
                                                                                                                    setExcelRows((prev) =>
                                                                                                                        prev.map((item, i) =>
                                                                                                                            i === originalIndex
                                                                                                                                ? item.map((cell, col) =>
                                                                                                                                    col === 3
                                                                                                                                        ? e.target.value
                                                                                                                                        : cell
                                                                                                                                )
                                                                                                                                : item
                                                                                                                        )
                                                                                                                    )
                                                                                                                }
                                                                                                            />
                                                                                                        ) : (
                                                                                                            row[3]
                                                                                                        )}
                                                                                                    </td>

                                                                                                    {/* Rating with position-based background color */}
                                                                                                    <td>
                                                                                                        <div
                                                                                                            style={{
                                                                                                                backgroundColor: ratingColor,
                                                                                                                color: "#000000",
                                                                                                                fontWeight: 600,
                                                                                                                padding: "8px",
                                                                                                                borderRadius: "4px",
                                                                                                                width: "100%",
                                                                                                                boxSizing: "border-box",
                                                                                                            }}
                                                                                                        >
                                                                                                            {editingAverageRows[originalIndex] ? (
                                                                                                                <input
                                                                                                                    className={`form-control  form-control-sm ${tableStyles.ratingInput}`}
                                                                                                                    placeholder="Rating"
                                                                                                                    value={row[4] ?? ""}
                                                                                                                    onChange={(e) =>
                                                                                                                        setExcelRows((prev) =>
                                                                                                                            prev.map((item, i) =>
                                                                                                                                i === originalIndex
                                                                                                                                    ? item.map((cell, col) =>
                                                                                                                                        col === 4
                                                                                                                                            ? e.target.value
                                                                                                                                            : cell
                                                                                                                                    )
                                                                                                                                    : item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }
                                                                                                                />
                                                                                                            ) : (
                                                                                                                row[4]
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>

                                                                                                    {/* Average Score */}
                                                                                                    <td>
                                                                                                        {editingAverageRows[originalIndex] ? (
                                                                                                            <input
                                                                                                                className={`form-control  form-control-sm ${tableStyles.ratingInput}`}
                                                                                                                placeholder="Average Score"
                                                                                                                value={row[5] ?? ""}
                                                                                                                onChange={(e) =>
                                                                                                                    setExcelRows((prev) =>
                                                                                                                        prev.map((item, i) =>
                                                                                                                            i === originalIndex
                                                                                                                                ? item.map((cell, col) =>
                                                                                                                                    col === 5
                                                                                                                                        ? e.target.value
                                                                                                                                        : cell
                                                                                                                                )
                                                                                                                                : item
                                                                                                                        )
                                                                                                                    )
                                                                                                                }
                                                                                                            />
                                                                                                        ) : (
                                                                                                            row[5]
                                                                                                        )}
                                                                                                    </td>

                                                                                                    {/* Actions */}
                                                                                                    <td>
                                                                                                        {editingAverageRows[originalIndex] ? (
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-success"
                                                                                                                title="Save"
                                                                                                                style={actionButtonStyle}
                                                                                                                onClick={() =>
                                                                                                                    handleSaveAverageRow(originalIndex)
                                                                                                                }
                                                                                                            >
                                                                                                                <i className="bi bi-check-circle" />
                                                                                                            </button>
                                                                                                        ) : (
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-outline-primary"
                                                                                                                title="Edit"
                                                                                                                style={actionButtonStyle}
                                                                                                                onClick={() =>
                                                                                                                    handleEditAverageRow(originalIndex)
                                                                                                                }
                                                                                                            >
                                                                                                                <i className="bi bi-pencil-square" />
                                                                                                            </button>
                                                                                                        )}

                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-outline-danger"
                                                                                                            title="Delete row"
                                                                                                            aria-label="Delete row"
                                                                                                            onClick={() =>
                                                                                                                handleDeleteExcelRow(originalIndex)
                                                                                                            }
                                                                                                            style={{
                                                                                                                width: "26px",
                                                                                                                height: "26px",
                                                                                                                border: "none",
                                                                                                                background: "transparent",
                                                                                                                color: "#000",
                                                                                                                padding: 0,
                                                                                                                cursor: "pointer"
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className="bi bi-trash3" style={{ fontSize: "14px" }} />
                                                                                                        </button>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}

                                                                                    {/* Newly added rating rows: always grey */}
                                                                                    {newAverageRows.map((row) => (
                                                                                        <tr key={`new-average-${row.id}`}>
                                                                                            {/* Section */}
                                                                                            <td>
                                                                                                <input
                                                                                                    className="form-control"
                                                                                                    placeholder="Section"
                                                                                                    value={row.section}
                                                                                                    onChange={(e) =>
                                                                                                        handleAverageRowChange(
                                                                                                            row.id,
                                                                                                            "section",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </td>

                                                                                            {/* Rating */}
                                                                                            <td>
                                                                                                <div
                                                                                                    className={tableStyles.ratingValue}
                                                                                                    style={{
                                                                                                        backgroundColor: NEW_RATING_COLOR,
                                                                                                        color: "#000000",
                                                                                                        fontWeight: 600,
                                                                                                        padding: "8px",
                                                                                                        borderRadius: "4px",
                                                                                                        width: "100%",
                                                                                                        minHeight: "42px",
                                                                                                        boxSizing: "border-box",
                                                                                                    }}
                                                                                                >
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className={`form-control form-control-sm ${tableStyles.ratingInput}`}
                                                                                                        placeholder="Rating"
                                                                                                        value={row.rating}
                                                                                                        onChange={(e) =>
                                                                                                            handleAverageRowChange(
                                                                                                                row.id,
                                                                                                                "rating",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                    />
                                                                                                </div>
                                                                                            </td>

                                                                                            {/* Average Score */}
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className={`form-control form-control-sm ${tableStyles.ratingInput}`}
                                                                                                    placeholder="Average Score"
                                                                                                    value={row.averageScore}
                                                                                                    onChange={(e) =>
                                                                                                        handleAverageRowChange(
                                                                                                            row.id,
                                                                                                            "averageScore",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </td>

                                                                                            {/* Actions */}
                                                                                            <td>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-success"
                                                                                                    title="Save"
                                                                                                    style={actionButtonStyle}
                                                                                                    onClick={() =>
                                                                                                        handleSaveNewAverageRow(row.id)
                                                                                                    }
                                                                                                >
                                                                                                    <i className="bi bi-check-circle" />
                                                                                                </button>

                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-danger"
                                                                                                    title="Delete row"
                                                                                                    aria-label="Delete row"
                                                                                                    onClick={() =>
                                                                                                        handleDeleteNewAverageRow(row.id)
                                                                                                    }
                                                                                                    style={{
                                                                                                        width: "26px",
                                                                                                        height: "26px",
                                                                                                        border: "1px solid var(--bs-danger)",
                                                                                                        background: "transparent",
                                                                                                        color: "var(--bs-danger)",
                                                                                                        padding: 0,
                                                                                                        cursor: "pointer"
                                                                                                    }}
                                                                                                >
                                                                                                    <i className="bi bi-trash3" style={{ fontSize: "14px" }} />
                                                                                                </button>

                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>

                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                    {/* </div> */}

                                                                </div>
                                                            </div>

                                                        </>

                                                    )}

                                                </div>
                                                {/* </div> */}

                                                <div className="d-flex justify-content-end gap-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-sm "
                                                        onClick={handleReset}
                                                    >
                                                        Reset
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        disabled={!isSubmitEnabled}
                                                        onClick={handleSubmit}

                                                    >
                                                        Submit
                                                    </button>
                                                    {/* </span> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <Modal
                                show={showModal}
                                onHide={handleCancel}
                                style={{ marginTop: '12vh' }}
                            >
                                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                    style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                marginBottom: '0px',
                                                color: messageType === 'success' ? 'green' : 'red',
                                                fontSize: '14px',
                                                whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: modalMessage.replace(/\n/g, '<br />')
                                            }}
                                        ></p>



                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                        onClick={handleCancel}>
                                    </button>

                                </div>
                            </Modal>

                            {/* <Modal
                                show={showReportingModal}
                                onHide={() => setShowReportingModal(false)}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    closeButton
                                    style={{
                                        background: "#366872",
                                        color: "#fff"
                                    }}
                                >
                                    <Modal.Title>
                                        Reporting Date Validation
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>

                                    {reportingMessage}

                                </Modal.Body>

                                <Modal.Footer>

                                    <Button
                                        variant="secondary"
                                        onClick={() => {

                                            setShowReportingModal(false);

                                            // Reset reporting date
                                            setReportingDate("");

                                            // Disable submit again
                                            setAllowSubmit(false);

                                        }}
                                    >
                                        No
                                    </Button>

                                    {!reportingMessage.includes("Permanent Area") && (

                                        <Button
                                            variant="primary"
                                            onClick={() => {

                                                setShowReportingModal(false);

                                                // Allow user to continue
                                                setAllowSubmit(true);

                                            }}
                                        >
                                            Yes
                                        </Button>

                                    )}

                                </Modal.Footer>

                            </Modal> */}

                            <Modal
                                show={showReportingModal}
                                onHide={() => {
                                    setShowReportingModal(false);
                                    setReportingDate("");
                                    setAllowSubmit(false);
                                }}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Reporting Date Validation
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    {reportingMessage}
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="Primary"
                                        style={
                                            submitButtonStyle
                                        }
                                        onClick={() => {
                                            setShowReportingModal(false);
                                            setReportingDate("");
                                            setAllowSubmit(false);
                                            restoreExcelValues();
                                        }}
                                    >
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyLeader;
